const TRANSLATION = {
  buyModal: {
    afterFree: 'તમારા ફ્રી ટ્રાયલ પછી',
    btn: 'તેને મફતમાં પ્રયત્ન કરો',
    freeTrial: '3-દિવસનો ફ્રી ટ્રાયલ',
    monthLabel: 'મહિનો',
    selectLabel: 'એક પ્લાન પસંદ કરો',
    title: 'સબ્સ્ક્રિપ્શન પ્લાન',
    yearLabel: 'વર્ષ',
  },
  contact: {
    block1:
      'કસ્ટમાઇઝેશન, પ્રશ્નો અથવા સૂચનાઓ માટે, કૃપા કરીને contact@noam.tools પર અમારો સંપર્ક કરો. અમે તરત જ પ્રતિસાદ આપીશું.',
    block2: 'અમને Google Apps એક્સ્ટેન્શન સ્ટોર પર ★★★★★ રેટ આપીને સપોર્ટ કરો.',
    block3: 'આ એક્સ્ટેન્શન શેર કરીને અન્યને મદદ કરો:',
    title: 'અમારો સંપર્ક કરો',
  },
  help: {
    AquickOverviewOfNoam: 'નોઅમનું ઝડપી üleવiew',
    ChatPDF: 'ચેટ પીડીએફ',
    ChatPDF2: 'ચેટપીડીએફ',
    FavoritesManagement: 'પસંદગીનું સંચાલન',
    Fixedplugin: 'ફિક્સ્ડ પ્લગિન',
    Focusing: 'કેન્દ્રീകരણ',
    Free: 'મફત',
    FreeTrialBenefits: 'ફ્રી ટ્રાયલ લાભો',
    GoWithWikipedia: 'વિકિપીડિયા સાથે જાઓ',
    GoWithYouTube: 'YouTube સાથે જાઓ',
    HoverTranslation: 'હોવર ટ્રાન્સલેશન',
    Howtouse: 'કેવી રીતે વાપરવું',
    ImageTranslation: 'ઇમેજ ટ્રાન્સલેશન',
    InstantTranslation: 'ઇન્સ્ટન્ટ ટ્રાન્સલેશન',
    Membership: 'સભ્યત્વ',
    NoamHelp: 'નોઅમ તમને અનુવાદ અને સારાંશ બનાવવામાં મદદ કરે છે',
    PDFparallelTranslation: 'પીડીએફ સમાંતર અનુવાદ',
    ParallelTranslation: 'સમાંતર અનુવાદ',
    SkipAllSteps: 'બધા પગલાં છોડો',
    Summary: 'સારાંશ',
    Translation: 'અનુવાદ',
    TryItForFree: 'તેને મફતમાં પ્રયત્ન કરો',
    Video: 'વિડિઓ',
    VideoSummary: 'વીડિયો સારાંશ',
    VideoTranslation: 'વીડિયો અનુવાદ',
    WebSummary: 'વેબ સારાંશ',
    WordSelectionTranslation: 'શબ્દ પસંદગી અનુવાદ',
    benefits: 'અમારી પાસે તમારા માટે લાભો રાહ જોઈ રહ્યા છે!',
    dayFree: '3-દિવસનો ફ્રી ટ્રાયલ',
    done: 'કર્યું',
    next: 'આગળ',
    pin: 'સરળ ઍક્સેસ માટે નોમને પિન કરો～～',
    planIsNotExist: 'પ્લાન ઉપલબ્ધ નથી',
    startWiki: 'ચાલો વિકિમીડિયા સાથે શરૂઆત કરીએ!',
    startYoutube: 'ચાલો YouTube સાથે શરૂઆત કરીએ!',
    try: 'તેને પ્રયત્ન કરો',
    tryNow: 'હવે તેને પ્રયત્ન કરો!',
  },
  home: {
    PDFTranslate: {
      desc: 'બાયલિંગ્વલ ટ્રાન્સલેશન + ચેટ પીડીએફ',
      sub1: {
        desc: 'બાયલિંગ્વલ વાંચન તમને મૂળ ટેક્સ્ટ અને અનુવાદને સાઇડ-બાય-સાઇડ સરખાવવા દે છે, જે વાંચન કાર્યક્ષમતામાં સુધારો કરે છે.',
        title: 'બાયલિંગ્વલ રીડિંગ',
      },
      sub2: {
        desc: 'AI વિશ્લેષણ કરે છે અને સારાંશ આપે છે, અને PDF સામગ્રીના આધારે તમારા પ્રશ્નોના જવાબ આપી શકે છે.',
        title: 'ચેટ પીડીએફ',
      },
      sub3: {
        desc: 'ઉચ્ચ સચોટતા અને કાર્યક્ષમતા માટે AI-સંચાલિત PDF અનુવાદ.',
        title: 'ચોકસાઈ અને કાર્યક્ષમતા',
      },
      title: 'પીડીએફ અનુવાદ',
    },
    aiAssistant: {
      desc: 'વેબ અનુવાદને સ્માર્ટ અને વધુ સુવિધાજનક બનાવવું',
      panel1: {
        desc: 'બાયલિંગ્યુઅલ ક્રોસ-રેફરન્સ ટ્રાન્સલેશન તમને મૂળ ટેક્સ્ટની ટ્રાન્સલેશન સાથે સરખામણી કરવામાં મદદ કરે છે જેથી તમે વધુ સારી રીતે સમજી શકો અને તમારી વાંચન કાર્યક્ષમતા સુધારી શકો. ',
        title: 'બાયલિંગ્યુઅલ અનુવાદ',
      },
      panel2: {
        left: {
          desc: 'વેબ પેજ બ્રાઉઝ કરતી વખતે, તમારે અનુવાદ કરવાની સામગ્રીના પર હોવર કરો જેથી અનુવાદ જોવા મળે.',
          title: 'હોવર ટ્રાન્સલેશન',
        },
        right: {
          desc: 'વેબ પેજ બ્રાઉઝ કરતી વખતે, તમે અનુવાદ જોવા માંગો છો તેવા ટેક્સ્ટને સિલેક્ટ કરો. ',
          title: 'ટેક્સ્ટ સિલેક્શન અનુવાદ',
        },
      },
      panel3: {
        one: {
          desc: 'સરળ અનુભવ માટે કોઈપણ સમયે, કોઈપણ સ્થળે વેબ પૃષ્ઠો અને વીડિયો સામગ્રીનું અનુવાદ અને સારાંશ બનાવો!',
          title: 'પોઇન્ટ અને ક્લિક',
        },
        three: {
          desc: 'એઆઈ-સંચાલિત મોટું ભાષા મોડેલ સુધારેલ વાંચન અનુભવ માટે અનુવાદની ચોકસાઈ અને સુસંગતતા સુનિશ્ચિત કરે છે.',
          title: 'એઆઈ-સંચાલિત',
        },
        two: {
          desc: 'બહુભાષી સંપૂર્ણ કવરેજ, બાયલિંગ્વલ અવરોધ-મુક્ત વાંચન, વન-ક્લિક અનુવાદ - તફાવત અનુભવો!',
          title: 'વધુ વ્યાપક અને સુવિધાજનક',
        },
      },
      panel4: {
        tab1: {
          desc: 'તમારા કાર્યક્ષમતા નિષ્ણાત - ChatGPT નો ઉપયોગ કરીને, નોઅમ YouTube વીડિયો સામગ્રીનું અનુવાદ અને સારાંશ આપે છે જેથી તમારો સમય બચે!',
          key: 'વિડિયો',
          title: 'વિડિઓ અનુવાદ અને સારાંશ',
        },
        tab2: {
          desc: 'વેબ બ્રાઉઝ કરતી વખતે ઇમેજનું અનુવાદ કરવા ક્લિક કરો.',
          key: 'પ્રતિમા',
          title: 'ઈમેજ ટ્રાન્સલેટ',
        },
        tab3: {
          desc: 'વેબ પૃષ્ઠોમાંથી કી માહિતીને તાત્કાલિક રીતે કાઢે છે અને સારાંશ પ્રદાન કરે છે, જે તમારી વાંચન કાર્યક્ષમતાને વધારે છે.',
          key: 'વેબ',
          title: 'વેબ અનુવાદ અને સારાંશ',
        },
        tag1: 'સરળ',
        tag2: 'કાર્યક્ષમ',
        tag3: 'સમજવા માટે સરળ',
      },
      title: 'એઆઈ સહાયક',
    },
    getStart: 'શરૂ કરો',
    getStartedForFree: 'મફતમાં સરૂ કરો',
    howItWork: {
      desc: 'નોઅમ એઆઈ મોડલ્સને એકીકૃત કરીને વપરાશકર્તાઓને ક્રોસ-લેન્ગ્વેજ વેબ પેજ અનુવાદ અને સારાંશ, પીડીએફ અને ઇમેજ અનુવાદ, વીડિયો અનુવાદ અને સારાંશ માટે બુદ્ધિશાળી અનુભવ પ્રદાન કરે છે',
      title: 'તે કેવી રીતે કામ કરે છે',
    },
    lastBlock: { desc: 'સરળ વાંચન અનુભવ માટે સારી AI અનુવાદ' },
    top: {
      desc: 'નોમ એક મફત AI બ્રાઉઝર એક્સ્ટેન્શન છે જે તમને વેબ પેજ, વીડિયો અને PDF સામગ્રીનું અનુવાદ અને સારાંશ બનાવવામાં મદદ કરે છે.\n      નોમ સાથે જોડાઓ અને જાદુનો અનુભવ કરો!',
      title1: 'એક મેજિક',
      title2: 'એક ક્લિક',
    },
    userReviews: { desc: 'ક્રોમ વેબ સ્ટોર પરની ફાઈવ-સ્ટાર સમીક્ષાઓ', title: 'વપરાશકર્તા સમીક્ષાઓ' },
  },
  installTips: {
    btn: 'હવે તેને પ્રયત્ન કરો',
    text: 'વધુ સુવિધાઓ અન્લોક કરવા માટે "નોઅમ બ્રાઉઝર પ્લગિન" ઇન્સ્ટોલ કરો! વેબ ક્રોસ-રેફરન્સિંગ,\n    વેબ વીડિયો સારાંશ, અને વધુ!',
  },
  locale: {
    af: 'આફ્રિકાન્સ',
    am: 'અમ્હારિક',
    ar: 'અરબી',
    as: 'અસામી',
    auto: 'ઓટો ડિટેક્ટ',
    az: 'અઝરબૈજાની',
    ba: 'બશ્કીર',
    bg: 'बल्गेरियन',
    bn: 'બંગલા',
    bo: 'ટિબેટી',
    bs: 'बोस्नियाई',
    ca: 'કેટલાન',
    cs: 'चेक',
    cy: 'વેલ્શ',
    da: 'ડેનિશ',
    de: 'જર્મન',
    dsb: 'લોવર સોર્બિયન',
    dv: 'ડિવેહી',
    el: 'ગ્રીક',
    en: 'અંગ્રેજી',
    es: 'સ્પેનિશ',
    et: 'एस्टोनियन',
    eu: 'બાસ્ક',
    fa: 'ફારસી',
    fi: 'ફિનન્શ',
    fil: 'ફિલિપિનો',
    fj: 'ફિજીયન',
    fr: 'ફ્રેન્ચ',
    frCA: 'ફ્રેન્ચ (કેનેડા)',
    ga: 'આઇરિશ',
    gl: 'ગેલિસિયન',
    gom: 'કોંકણી',
    gu: 'ગુજરાતી',
    ha: 'હાઉસા',
    he: 'હીબ્રુ',
    hi: 'હિન્દી',
    hr: 'क्रोएशियन',
    hsb: 'ઉપર સોર્બિયન',
    ht: 'હેટીયન ક્રિઓલ',
    hu: 'હંગેરી',
    hy: 'અર્મેનિયન',
    id: 'ઇન્ડોનેશિયન',
    ig: 'ઇગ્બો',
    ikt: 'ઇનુઈનનાક્તુન',
    is: 'आइसल्यांडिक',
    it: 'ઇટાલિયન',
    iu: 'ઇનુક્ટિટુટ',
    iuLatn: 'ઇનુક્ટિટુટ (લેટિન)',
    ja: 'જાપાનીઝ',
    ka: 'જ્યોર્જિયન',
    kk: 'કાઝાક',
    km: 'ખ્મેર',
    kmr: 'કુર્દીશ (ઉત્તરી)',
    kn: 'ಕನ್ನಡ',
    ko: 'કોરિયન',
    ku: 'કુર્દીશ (સેન્ટ્રલ)',
    ky: 'કીર્ગિસ',
    ln: 'લિંગાલા',
    lo: 'લાઓ',
    lt: 'लिथुआनियन',
    lug: 'ગાંડા',
    lv: 'લાત્વિયન',
    lzh: 'ચાઇનીઝ (સાહસ્ત્રિક)',
    mai: 'મૈથિલી',
    mg: 'મલાગાસી',
    mi: 'माओरी',
    mk: 'मॅसेडोनियन',
    ml: 'മലയാളം',
    mnCyrl: 'મોંગોલીયન (સાયરિલિક)',
    mnMong: 'मंगोलियन (परंपरागत)',
    mr: 'मराठी',
    ms: 'મલય',
    mt: 'માલ્ટીઝ',
    mww: 'હોમાંગ ડૉ',
    my: 'મ્યાન્માર (બર્મી)',
    nb: 'નોર્વેજીયન',
    ne: 'नेपाली',
    nl: 'ડચ',
    noSearchLang: 'ભાષા સપોર્ટેડ નથી',
    nso: 'સેસોથો સા લેબોઆ',
    nya: 'ન્યાન્જા',
    or: 'ઓડિયા',
    otq: 'ક્વેરેટારો ઓટોમી',
    pa: 'પંજાબી',
    pl: 'પોલિશ',
    placeholder: 'શોધો',
    prs: 'દારી',
    ps: 'પાશ્તો',
    pt: 'પોર્ટુગીઝ (બ્રાઝિલ)',
    ptPT: 'પોર્ટુગીઝ (પોર્ટુગલ)',
    ro: 'રોમાનિયન',
    ru: 'રશિયન',
    run: 'રુંડી',
    rw: 'કિન્યારવાન્ડા',
    sd: 'સિન્ધી',
    si: 'සිංහල',
    sk: 'સ્લોવાક',
    sl: 'स्लोवेनियन',
    sm: 'સામોઆન',
    sn: 'શોના',
    so: 'સોમાલી',
    sq: 'अल्बानियाई',
    srCyrl: 'सर्बियन (सिरिलिक)',
    srLatn: 'सर्बियन (લેટિન)',
    st: 'સેસોથો',
    sv: 'स्वीडिश',
    sw: 'સ્વાહિલી',
    ta: 'તમિલ',
    te: 'તેલગુ',
    th: 'થાઈ',
    ti: 'ટિગ્રિન્યા',
    tk: 'તુર્કમેન',
    tlhLatn: 'ક્લિંગન',
    tlhPiqd: 'ક્લિંગન (pIqaD)',
    tn: 'સેટ્સ્વાના',
    to: 'ટોંગન',
    tr: 'તુર્કીશ',
    tt: 'તાતાર',
    ty: 'ताहिती',
    ug: 'ਯੂਇਘੁਰ',
    uk: 'યુક્રેની',
    ur: 'ઉર્દુ',
    uz: 'ઉઝ્બેક (લેટિન)',
    vi: 'વિયેતનામી',
    xh: 'झोसा',
    yo: 'યોરુબા',
    yua: 'યુકાટેક માયા',
    yue: 'કેન્ટોનીઝ (પરંપરાગત)',
    zh: 'ચીની',
    zhHans: 'ચીની સરળીકૃત',
    zhHant: 'ચાઈનીઝ ટ્રેડીશનલ',
    zu: 'ઝુલુ',
  },
  login: {
    and: 'અને',
    btn: 'ગૂગલ સાથે લોગ ઇન કરો',
    btn1: 'હવે લોગ ઇન કરો',
    desc: 'વધુ અનુભવો અનલોક કરવા માટે લોગ ઇન કરો',
    policy: 'ગોપનીયતા નીતિ',
    terms: 'ઉપયોગની શરતો',
    tips: 'સાઇન અપ કરીને, હું સાથે સંમત થઇ છું',
    title: 'નોમमध्ये આપનું સ્વાગત છે',
  },
  pageFooter: {
    follow: { facebook: 'ફેસબુક', title: 'ફોલો', twitter: 'ટ્વિટર' },
    legal: { policy: 'ગોપનીયતા નીતિ', terms: 'સેવા શરતો', title: 'કાનૂની' },
    product: {
      image: 'ઇમેજ ટ્રાન્સલેશન',
      pdf: 'પીડીએફ અનુવાદ',
      title: 'ઉત્પાદનો',
      video: 'વીડિયો અનુવાદ અને સારાંશ',
      web: 'વેબ અનુવાદ અને સારાંશ',
    },
    resources: { title: 'સંસાધનો' },
    tools: { title: 'સાધનો', pdf: 'પીડીએફ અનુવાદ' },
  },
  pageHeader: {
    contact: 'સંપર્ક',
    help: 'મદદ',
    logout: 'લૉગ આઉટ',
    logoutSucc: 'લોગ આઉટ થયા છે.',
    pricing: 'કિમતકરણ',
    settings: 'સેટિંગ્સ',
    signUp: 'લોગ ઇન',
  },
  pdf: {
    autoDetect: 'ઓટો-ડિટેક્ટ',
    cancelBtn: 'રદ કરવું',
    cancelUpload: 'રદ કરો',
    chatPdf: {
      summaryError: 'સારાંશ નિષ્ફળ થયો, કૃપા કરીને પાછળથી પ્રયાસ કરો',
      chatError: 'ચેટ નિષ્ફળ થયું, કૃપા કરીને પાછળથી પ્રયાસ કરો',
      Search: 'શોધો',
      cancel: 'રદ કરવું',
      chatTitle: 'નોમमध्ये આપનું સ્વાગત છે! અહીં તમારા પીડીએફનો સારાંશ છે:',
      clear: 'સ્પષ્ટ',
      clearContent: 'આ એક નવું વાતચીત શરૂ કરશે. વર્તમાન વાતચીત સાચવવામાં આવશે નહીં. તમે ખાતરી છે?',
      clearDialogTitle: 'કૃપા કરીને પુષ્ટિ કરો',
      clearSucc: 'ક્લિયર થયેલ',
      copy: 'કોપી',
      copySucc: 'કોપી કર્યું',
      delete: 'કાઢી નાખો',
      deleteCancel: 'રદ કરવું',
      deleteContent: 'ડીલીટ કર્યા પછી આ PDF પુનઃ પ્રાપ્ત કરી શકાતી નથી. તમે ખાતરીથી ચાંહો છો?',
      deleteOk: 'કાઢી નાખો',
      deleteSuccess: 'હટાવી ગઈ',
      deleteTitle: 'કન્ફર્મ ડિલીટ',
      expand: 'ધસાર',
      historyTitle: 'ઇતિહાસ',
      listError:
        'રીડીંગ લિસ્ટ લોડ કરવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો.',
      loading: 'લોડ કરી રહ્યું છે...',
      noDataDesc: 'હજુ સુધી કોઈ ઇતિહાસ નથી.',
      noMore: 'વધુ સામગ્રી નથી.',
      placeholder: 'આ PDF વિશે કંઈપણ પૂછો',
      summaryTitle: 'તમને આ પ્રશ્નોમાં રસ હોઈ શકે છે:',
    },
    collectionEmpty: 'તમારું સંગ્રહ ખાલી છે.',
    collectionTab: 'નોંધ',
    dataLoading: 'લોડ કરી રહ્યું છે...',
    dialogContent: 'શું તમે ખાતરીથી આને ડિલીટ કરવા চाहतા છો?',
    dialogTitle: 'કૃપા કરીને પુષ્ટિ કરો',
    download: {
      both: 'બાયલિંગ્વલ',
      btn: 'સાચવો',
      cancel: 'આ વિન્ડો બંધ કરવાથી PDF ડાઉનલોડ રદ થશે. તમે ખરેખર રદ કરવા માંગો છો?',
      desc: 'ડિવાઇસ પર સેવ કરો: અનુવાદોને ઇમેજ તરીકે ડાઉનલોડ કરે છે; સેવ અને પ્રિન્ટ કરો: અનુવાદોને મૂળ ફોર્મેટમાં ડાઉનલોડ કરે છે, કોપી સપોર્ટ સાથે.',
      download: 'ડાઉનલોડ',
      downloadMsg1: 'પીડીએફ અનુવાદ પ્રગતિ:',
      downloadMsg2: 'અનુમાનિત બાકી સમય:',
      downloadSucc: 'પીડીએફ તૈયાર છે! સાચવવા માટે ક્લિક કરો. ',
      downloadTip:
        'પીડીએફ ડાઉનલોડ થઈ રહ્યું છે. ડાઉનલોડની ભૂલોને ટાળવા માટે આ વિન્ડો બંધ કરશો નહીં.',
      error: 'સેવ કરવામાં નિષ્ફળ. bunun yerine પ્રિન્ટ કરવાનો પ્રયાસ કરો.',
      fileName: 'ફાઇલ નામ:',
      fileType: 'ફાઇલ પ્રકાર:',
      loading: 'સેવિંગ કરી રહ્યું છે...',
      loading2: 'લોડ કરી રહ્યું છે...',
      minute: 'મિનિટ્સ...',
      msg1: 'આ દસ્તાવેજમાં કેટલીક અનુવાદો મૂળ ટેક્સ્ટ કરતાં લાંબી છે, અને ડાઉનલોડ કરેલ ફાઇલમાં ઓવરલેપ થઈ શકે છે. અમે વેબપેજ પર વાંચવાની ભલામણ કરીએ છીએ.',
      msg2: 'અનુવાદ હજુ સુધી પૂર્ણ નથી. અનુવાદ પૂર્ણ થયા પછી કૃપા કરીને ડાઉનલોડ કરો. ',
      msg3: '2. કેટલીક અનુવાદો ખૂબ લાંબા છે. ટેક્સ્ટ ઓવરલેપ ટાળવા વેબપેજ પર વાંચો.',
      msg4: 'અનુવાદ કાર્યો ચાલી રહ્યાં છે. તે પૂર્ણ થયા પછી ફરીથી પ્રયાસ કરો.',
      progress:
        'પીડીએફ અનુવાદ કરી રહ્યાં છો. પ્રગતિ: {{progress}}, અવશેસ્ત સમય: {{minutes}} મિનિટ...',
      save: 'ડિવાઇસ પર સેવ કરો',
      savePrint: 'સેવ કરો અને પ્રિન્ટ કરો',
      success: 'ડાઉનલોડ કર્યું',
      trans: 'ફક્ત અનુવાદ',
      transContinue: 'અનુવાદ ચાલુ રાખો',
    },
    downloadBtn: 'ડાઉનલોડ',
    dragTipModal: {
      black: 'જગ્યા',
      leftKey: 'ડાબો બટન',
      ok: 'સમજ્યું',
      press: 'પ્રેસ',
      tips: 'ડ્રેગ અને જોવા',
    },
    entry: 'પીડીએફ્સ',
    fileErrMsg:
      'ફાઇલ વાંચવામાં નિષ્ફળતા. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    fileMsg: 'વર્તમાન ફાઇલ કક્ષા:',
    fileMsg2: 'કૃપા કરીને 300MB કરતા નાની ફાઇલ અપલોડ કરો.',
    freeBannerBtn: 'અપગ્રેડ',
    freeBannerTips: 'ફ્રી PDF અનુવાદની મર્યાદા પૂરી થઈ ગઈ છે',
    guide: {
      placeholder: 'PDF લિંક અહીં પેસ્ટ કરો',
      start: 'અનુવાદ કરવાનું શરૂ કરો',
      text1: 'બાઇલિંગ્વલ રીડિંગ',
      text2:
        'મૂળ ટેક્સ્ટ અને અનુવાદને સાઇડ-બાય-સાઇડ સરખાવવા માટે દ્વીભાષી રીતે વાંચો, તમારી કાર્યક્ષમતા વધારવા માટે.',
      text3: 'તમારા PDF સાથે ચેટ કરો',
      text4:
        'એઆઈ-સક્ષમ વિશ્લેષણ અને સારાંશ. તમારા પીડીએફ વિશે પ્રશ્નો પૂછો, અને તાત્કાલિક જવાબો મેળવો. ',
      text5: 'સચોટ અને કાર્યક્ષમ',
      text6: 'ઘણી ચોકસાઈ અને કાર્યક્ષમતા માટે AI-સક્ષમ PDF અનુવાદ.',
      title1: 'બાઇલિંગ્વલ અનુવાદ',
      title2: 'તમારા PDF સાથે ચેટ કરો',
      toast: '.pdf અંતે સમાપ્ત થતું માન્ય ઓનલાઇન PDF લિંક દાખલ કરો',
    },
    hasTransTask: 'અનુવાદ કાર્ય ચાલુ છે. કૃપા કરીને રાહ જુઓ.',
    hoverTrans: 'હોવર-ટુ-ટ્રાન્સલેટ પેરાગ્રાફ્સ',
    initial: 'પીડીએફ અનુવાદ કરો',
    installText: 'દૈનિક અનુવાદ માટેનું તમારું એક-સ્ટોપ સોલ્યુશન.',
    installText2: 'પ્રથમ ઍક્સ્ટેન્શન ઇન્સ્ટોલ કરો',
    installTips: 'ઔર પણ વધુ PDF અનુવાદો અને સરળ વેબસાઇટ અનુવાદો માટે એક્સ્ટેન્શન ઇન્સ્ટોલ કરો:',
    kw: 'મુખ્ય ખોરાક',
    link: 'લિંક',
    listError:
      'PDF લોડ કરવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયત્ન કરો અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    memoTotalCount: 'કુલ 1 વસ્તુ',
    new: 'નવી ફાઇલ',
    noId: 'ફાઇલ ID મળી નથી. ',
    notPdf: 'ફક્ત PDF ફાઇલો.',
    okBtn: 'કાઢી નાખો',
    okBtn2: 'સમજ્યું',
    original: 'ઓરિજિનલ',
    parallel: 'સમાંતર',
    parseErrDialogContent:
      'આ PDF લિંકનો સીધો અનુવાદ કરી શકાતો નથી. કૃપા કરીને PDF ડાઉનલોડ કરો અને અનુવાદ માટે અપલોડ કરો. ',
    parseErrTips: 'ફાઇલ પાર્સ કરવામાં નિષ્ફળ',
    parseFileToast:
      'ફાઇલ પાર્સ કરવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો.',
    pdfLoading: 'પાર્સિંગ કરી રહ્યા છે...',
    searchPlaceholder: 'શોધો',
    selectTrans: 'અનુવાદ કરવા માટે ટેક્સ્ટ પસંદ કરો',
    shareBtn: 'શેર કરો',
    shareBtnText1: 'શેર લિંક બનાવો',
    shareBtnText2: 'શેર કરેલ સામગ્રી અપડેટ કરો',
    shareModal: {
      cancel: 'રદ કરવું',
      copy: 'કોપી',
      copySucc: 'લિંક કોપી કર્યો',
      custom: 'કસ્ટમાઇઝ કરો',
      errMsg:
        'પસંદ કરેલ સામગ્રી હજુ સુધી સંપૂર્ણ રીતે અનુવાદ થઈ નથી. શેર કરતા પહેલા કૃપા કરીને અનુવાદ કરો. ',
      gen: 'શેર કરો',
      modify: 'સંપાદન',
      notSupport: 'આ ભાષા હાલમાં સપોર્ટેડ નથી.',
      page: 'પૃષ્ઠો',
      pageNuErr: 'કૃપા કરીને માન્ય પૃષ્ઠ નંબર દાખલ કરો. ',
      range: 'કક્ષા:',
      remain: 'બાકી',
      remain1: 'કુલ અંદાજિત સમય:',
      search: 'શોધ',
      settings: 'શેર સેટિંગ્સ:',
      shareSetting: 'શેર સેટિંગ્સ',
      shareText: 'શેર કરો',
      shareTips: 'અનુવાદિત PDF લિંક તમારા મિત્રો સાથે શેર કરો:',
      sourceLang: 'થી:',
      target: 'ને:',
      text1: 'શેર સેટિંગ્સ',
      text2: 'શેર લિંક બનાવો',
      totalPage: 'કુલ 1 પૃષ્ઠ',
      trans: 'અનુવાદ',
      translateTips:
        'ટીપ: જો અનુવાદમાં થોડો સમય લાગે છે, તો તમે આ વિન્ડો બંધ કરી અને પાછળથી શેર કરી શકો છો. ',
      translating: 'પીડીએફ અનુવાદ કરી રહ્યું છે...',
      update: 'શેર લિંક અપડેટ કરો',
    },
    shareMsg1: 'શેર લિંક જનરેટ થયો છે.',
    shareMsg2: 'શેર કરેલ સામગ્રી અપડેટ થઈ ગઈ છે.',
    shareMsg3:
      'શેર લિંક જનરેટ કરવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    shareMsg4:
      'શેર કરેલ સામગ્રીને અપડેટ કરવામાં નિષ્ફળતા. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    shareTips: 'તમારું PDF અનુવાદ તૈયાર છે! તેને તમારા મિત્રો સાથે શેર કરો.',
    start: 'તમારો ફ્રી ટ્રાયલ શરૂ કરો',
    thumbnail: 'સામગ્રીનું કોષ્ટક',
    toast1: 'PDF લોડ કરી રહ્યું છે. કૃપા કરીને પાછળથી પ્રયાસ કરો. ',
    toast2: 'પીડીએફ સામગ્રીની પ્રક્રિયા કરવામાં આવી રહી છે. સંવાદ હાલમાં અધિકૃત નથી.',
    toast3: 'ડાઉનલોડ કરી રહ્યું છે. ડાઉનલોડ પૂર્ણ થયા પછી ફરીથી પ્રયાસ કરો. ',
    toolbar: { Adjust: 'समायोजित કરવું', autoFit: 'ઓટો-ફિટ' },
    trans: 'અનુવાદ',
    transSucc: 'અનુવાદ સફળ થયો!',
    unLoginToast: 'આ સુવિધાનો ઉપયોગ કરવા માટે પ્રવેશ કરો.',
    uploadBtn: 'અપલોડ કરો',
    uploadErr: 'ફાઇલ અપલોડ નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયત્ન કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો.',
    uploadErrSignUrl:
      'અપલોડ URL મેળવવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયત્ન કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    uploadMsg1: 'તમારું ફાઇલ અહીં ડ્રેગ અને ડ્રોપ કરો.',
    uploadMsg2: 'સપોર્ટેડ ફાઇલ પ્રકારો: PDF  |  મેક્સ ફાઇલ સાઇઝ: 300MB',
    uploadMsg3: 'ફાઇલો પસંદ કરવા માટે ક્લિક કરો અથવા અહીં ખેંચી અને છોડો.',
    uploading: 'અપલોડ કરી રહ્યું છે',
    uploadingMsg: 'અપલોડ કરી રહ્યા છીએ. કૃપા કરીને રાહ જુઓ.',
    uploadingMsg1: 'ફાઇલ અપલોડ થઈ રહી છે. કૃપા કરીને પાછળથી પ્રયાસ કરો.',
    uploadingMsg2: 'ફાઇલ હાલમાં કન્વર્ટ થઈ રહી છે. કૃપા કરીને પાછળથી પ્રયાસ કરો.',
    uploadingMsg3:
      'કન્વર્ઝન પ્રગ્રેસ વિનંતી નિષ્ફળ થઈ. કૃપા કરીને પાછળથી પ્રયત્ન કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    uploadingMsg4:
      'નોમ સ્થાનિક ફાઇલો ઍક્સેસ કરી શકતું નથી. કૃપા કરીને અનુવાદ માટે મેન્યુઅલી પીડીએફ અપલોડ કરો. ',
    uploadingMsg5:
      'ફાઇલ URL પ્રાપ્ત કરવામાં નિષ્ફળ. કૃપા કરીને પાછળથી પ્રયાસ કરો, અથવા સપોર્ટ સાથે સંપર્ક કરો. ',
    video: 'વિડિયો',
    vipBannerBtn: 'અપગ્રેડ',
    vipBannerTips: 'તમે આ મહિનાની તમારી PDF અનુવાદ મર્યાદા સુધી પહોંચ્યા છો.',
    webTrans: 'સંપૂર્ણ ક્રોસ-રેફરન્સ',
  },
  pricing: {
    FAQ: 'વારંવાર પૂછાતા પ્રશ્નો',
    FQAObj: {
      a1: 'હા, નોઅમ એક ફ્રી પ્લાન ઓફર કરે છે જેનો તમે તરત જ ઉપયોગ કરી શકો છો.',
      a2: 'અમે ત્રણ મેમ્બરશીપ પ્લાન ઓફર કરીએ છીએ: પ્રો, પ્રો+, અને એન્ટરપ્રાઇઝ. તમે માસિક અથવા વાર્ષિક ચૂકવણી કરવાનું પસંદ કરી શકો છો. વાર્ષિક બિલિંગ નોંધપાત્ર બચતો પ્રદાન કરે છે.',
      a3: 'બંને પ્લાન્સ પર તમામ સુવિધાઓ ઉપલબ્ધ છે. મુખ્ય તફાવત કિંમત છે: વાર્ષિક સબ્સ્ક્રિપ્શન્સની એકંદર કિંમત ઓછી છે. માસિક સબ્સ્ક્રિપ્શન્સ દર મહિને બિલ કરવામાં આવે છે, જ્યારે વાર્ષિક પ્લાન્સ દર વર્ષે એકવાર બિલ કરવામાં આવે છે.',
      a4: 'તમારા એકાઉન્ટ સેટિંગ્સમાંથી તમે કોઈપણ સમયે તમારું સબ્સ્ક્રિપ્શન રદ કરી શકો છો.',
      q1: 'શું કોઈ ફ્રી પ્લાન છે?',
      q2: 'કયા કિમત પ્લાન્સ અને પેમેન્ટ વિકલ્પો ઉપલબ્ધ છે?',
      q3: 'માસિક સબ્સ્ક્રાઇબ કરતા અને વાર્ષિક સબ્સ્ક્રાઇબ કરતા વચ્ચે શું તફાવત છે?',
      q4: 'મારું સબસ્ક્રિપ્શન કેવી રીતે રદ કરવું?',
    },
    around: '必要周围',
    billedMonthly: 'માસિક બિલ',
    billedYearly: 'વાર્ષિક બિલ કરવામાં આવે છે',
    day: 'દિવસ',
    desc: 'યોજનાઓની સરખામણી કરો અને શ્રેષ્ઠ પસંદ કરો',
    detailedCompare: 'યોજનાઓની તુલના કરો',
    discount: '20% ઘટાડો',
    enterprise: {
      benefit1: 'પ્રાથમિકતા ગ્રાહક સપોર્ટ',
      benefit2: 'બહુવતી વપરાશકર્તાઓ',
      benefit3: 'ટેલર્ડ સોલ્યુશન્સ',
      benefit5: 'નિષ્ઠાવાન એકાઉન્ટ મેનેજર',
      btn: 'અમારો સંપર્ક કરો',
      recommendText: 'કસ્ટમ પ્લાન્સ（≥3 વ્યક્તિ）',
      talkToUs: 'સંપર્ક કરો',
    },
    free: {
      benefit1: 'તાત્કાલિક અનુવાદ 100 વાર/દિવસ',
      benefit2: 'વેબસાઇટ અનુવાદ અને સારાંશ',
      benefit3: '30 ઇમેજ ટ્રાન્સલેશન્સ',
      benefit4: 'વીડિયો અનુવાદ અને સારાંશ',
      benefit5: '10 PDF અનુવાદો',
      benefit6: '5,000 ટોકન',
      btn: 'તેને ફ્રી માં પ્રયત્ન કરો',
      recommendText: 'મફત અજમાવટ',
    },
    imageTranslation: 'ઈમેજ અનુવાદ',
    month: 'મહિનો',
    monthly: 'માસિક',
    pageTitle: 'કિંમત નિર્ધારણ',
    pdf: {
      chat: 'પીડીએફ ચેટ ક્વેરીઝ',
      maxPage: 'પ્રતિ PDF મહત્તમ પૃષ્ઠો',
      translation: 'પીડીએફ અનુવાદ',
    },
    preMonth: 'પ્રતિ મહિનો',
    pro: {
      benefit1: 'પ્રાથમિકતા ગ્રાહક સપોર્ટ',
      benefit2: '1,000,000 ટોકન/મહિનું',
      benefit3: 'વેબસાઇટ અનુવાદ અને સારાંશ',
      benefit4: '200 ઇમેજ ટ્રાન્સલેશન્સ',
      benefit5: 'વીડિયો અનુવાદ અને સારાંશ',
      benefit6: '200 PDF અનુવાદો',
      btn: 'શરૂ કરો',
      recommendText: 'સૌથી લોકપ્રિય',
    },
    proPlus: {
      benefit1: 'પ્રાયોરિટી ગ્રાહક સપોર્ટ',
      benefit2: '30,00,000 ટોકન/મહિનો',
      benefit3: 'વેબસાઇટ અનુવાદ અને સારાંશ',
      benefit4: '500 ઇમેજ ટ્રાન્સલેશન્સ',
      benefit5: 'વીડિયો અનુવાદ અને સારાંશ',
      benefit6: '500 PDF અનુવાદો',
      recommendText: 'શ્રેષ્ઠ મૂલ્ય',
    },
    video: { summary: 'વિડિઓ સારાંશ', translation: 'વિડિઓ અનુવાદ' },
    web: {
      contrastiveTranslation: 'બાયલિંગ્યુઅલ અનુવાદ',
      dictionaryTranslation: 'સિલેક્શન ટ્રાન્સલેશન',
      hoverTranslation: 'હોવર ટ્રાન્સલેશન',
      instantTranslation: 'તાત્કાલિક અનુવાદ',
      summary: 'વેબ પેજ સારાંશ',
    },
    yearly: 'વાર્ષિક',
  },
  privacy: {
    block1:
      'નોઅમ ("નોઅમ," "અમે," "અમારું" અથવા "અમને") તમારી ગોપનીયતાનો આદર કરે છે અને તમારી પાસેથી અથવા તમારા વિશે આપણે મેળવેલ કોઈપણ માહિતીનું સંરક્ષણ કરવા માટે પ્રતિબદ્ધ છે. આ ગોપનીયતા નીતિ આપણી વેબસાઇટ, એપ્લિકેશન્સ અને સેવાઓ (સામૂહિક રીતે "સેવાઓ")ના ઉપયોગથી વ્યક્તિગત માહિતીના સંગ્રહ અથવા ઉપયોગને લગતી આપણી પ્રથાઓનું વર્ણન કરે છે. આ ગોપનીયતા નીતિ આપણા બિઝનેસ પ્રોડક્ટ ગ્રાહકોની તરફથી હેન્ડલ કરેલ સામગ્રી પર લાગુ પડતી નથી, જેમ કે આપણું API. આ ડેટાનો ઉપયોગ આપણા ગ્રાહક કરારને આધારે છે, જે આ પ્રોડક્ટ્સની ઍક્સેસ અને ઉપયોગને આવરી લે છે.',
    block10:
      'અમે વ્યાપારી રીતે વાજબી તકનીકી、પ્રશासનિક અને સંગઠનાત્મક પગલાં લગાવીએ છીએ જેથી ઑનલાઇન અને ઑફલાઇન વ્યક્તિગત માહિતીને નુકશાન、ગેરવપરાશ、 અને અધિકૃત ઍક્સેસ、પ્રકાશન、ફેરફાર અથવા હત્યારી કૃત્યોથી બચાવી શકાય. જો કે, કોઈપણ ઇન્ટરનેટ અથવા ઈમેલ ટ્રાન્સમિશન સંપૂર્ણ સુરક્ષા અથવા સચોટતાની ضمانત આપી શકતું નથી. ખાસ કરીને, અમને મોકલેલા અથવા અમારી પાસેથી મોકલેલા ઈમેલ સુરક્ષિત ન હોઈ શકે. તેથી, સર્વિસ અથવા ઈમેલ દ્વારા અમને કયું માહિતી મોકલવું છે તે નક્કી કરતી વખતે તમારે ખાસ જ સાવચેત રહેવું જોઈએ. વધુમાં, સર્વિસ અથવા તૃતીય પક્ષ વેબસાઈટ્સની પ્રાઇવસી સેટિંગ્સ અથવા સુરક્ષા મેઝર્સમાં કોઈપણ અવરોધ માટે અમે જવાબદાર નથી. અમે તમારી વ્યક્તિગત માહિતી એટલી લાંબી સમય સુધી રાખીશું જેટલી સમય સુધી તમને સેવાઓ પ્રદાન કરવા અથવા અન્ય કાયદેસર વ્યાપાર હેતુઓ જેમ કે વિવાદો ઉકેલવા、સુરક્ષા અને સલામતી કારણો અથવા અમારી કાયદેસર જવાબદારીઓનું પાલન કરવા જરૂરી છે. અમે વ્યક્તિગત માહિતી કેટલી લાંબી સમય સુધી રાખીએ છીએ તે ઘણા પરિબળોન પર આધાર રાખે છે, જેમ કે માહિતીનું પ્રમાણ、પ્રકૃતિ、સંવેદનશીલતા、અધિકૃત ઉપયોગ અથવા પ્રકાશનના સંભવિત જોખમો、જે હેતુઓ માટે અમે માહિતીની પ્રક્રિયા કરીએ છીએ અને અન્ય કાયદેસર બંધબેસતા વિચારો. ',
    block11:
      'અમે સમયાંતરે આ ગોપનીયતા નીતિને અપડેટ કરી શકીએ છીએ. જ્યારે આપણે આવું કરીએ છીએ, ત્યારે આપણે આ પૃષ્ઠ પર અપડેટ કરેલી સંસ્કરણ પોસ્ટ કરીશું, સિવાય કે લાગુ કાયદા દ્વારા અન્યथા જરૂરી હોય ત્યાં સિવાય.',
    block12:
      'જો તમારી પાસે આ ગોપનીયતા નીતિ અંગે કોઈ બિનજવાબ પ્રશ્નો અથવા ચિંતાઓ છે, તો કૃપા કરીને અમારી ગ્રાહક સેવા સાથે સંપર્ક કરો. ઇમેઇલ:',
    block2:
      'અમે તમારી સંબંધિત નીચે પ્રક્રમાં વ્યક્તિગત માહિતી ("પર્સનલ ઇન્ફોર્મેશન") એકત્રિત કરીએ છીએ:',
    block3:
      'તમારા દ્વારા પ્રદાન કરેલ માહિતી: જ્યારે તમે અમારી સેવાઓનો ઉપયોગ કરવા અથવા અમારી સાથે સંચાર કરવા માટે એકાઉન્ટ બનાવો છો, ત્યારે અમે નીચે પ્રમાણે વ્યક્તિગત માહિતી એકત્રિત કરીએ છીએ:',
    block4:
      'સેવાઓના તમારા ઉપયોગથી આપમેળે પ્રાપ્ત થતી વ્યક્તિગત માહિતી: જ્યારે તમે સેવાઓને ઍક્સેસ કરો, ઉપયોગ કરો અથવા તેની સાથે ક્રિયાપ્રતિક્રિયા કરો, ત્યારે અમને તમારી ઍક્સેસ, ઉપયોગ અથવા ક્રિયાપ્રતિક્રિયા વિશે નીચે પ્રકારની માહિતી પ્રાપ્ત થાય છે ("તકનીકી માહિતી"):',
    block5: 'અમે નીચેના હેતુઓ માટે વ્યક્તિગત માહિતીનો ઉપયોગ કરી શકીએ છીએ:',
    block6:
      'સારાંશ અથવા વીજી-ઓળખની માહિતી: આપણે વ્યક્તિગત માહિતીને એકત્રિત અથવા વીજી-ઓળખની બનાવી શકીએ છીએ જેથી તેનો ઓળખના હેતુઓ માટે પુનઃપ્રયોગ અટકાવી શકાય અને આવી માહિતીનો ઉપયોગ આપણી સેવાઓની અસરકારકતાનું વિશ્લેષણ કરવા, આપણી સેવાઓને સુધારવા અને ફીચર્સ ઉમેરવા, સંશોધન કરવા અને સમાન હેતુઓ માટે કરી શકાય છે. વધુમાં, આપણે આપણી સેવા વપરાશકર્તાઓના સામાન્ય વર્તન અને લાક્ષણિકતાઓનું વિશ્લેષણ કરી શકીએ છીએ અને એકત્રિત માહિતીને તૃતીય પક્ષો સાથે શેર કરી શકીએ છીએ, આવી એકત્રિત માહિતીનું પ્રકાશન કરી શકીએ છીએ અથવા તેને સામાન્ય રીતે ઉપલબ્ધ કરી શકીએ છીએ. આપણે સેવાઓ દ્વારા, કુકીઝ દ્વારા અને આ ગોપનીયતા નીતિમાં વર્ણવેલી અન્ય માધ્યમો દ્વારા એકત્રિત માહિતી એકત્રિત કરી શકીએ છીએ. આપણે વીજી-ઓળખની માહિતીને અનન્ય અથવા વીજી-ઓળખની સ્વરૂપમાં જાળવી રાખી અને ઉપયોગ કરીશું, અને કાયદા દ્વારા જરૂરી ન હોય ત્યાં સુધી આપણે આવી માહિતીને પુનઃઓળખવાનો પ્રયાસ કરીશું નહીં.',
    block7:
      'કેટલાક કિસ્સાઓમાં, કાયદા દ્વારા જરૂરી ન હોય ત્યાં સુધી તમને વધારાની સૂચના વિના અમે તમારી વ્યક્તિગત માહિતી તૃતીય પક્ષોને પ્રદાન કરી શકીએ છીએ:',
    block8:
      'તમારા ભૌગોલિક સ્થાન પર આધાર રાખીને, યુરોપિયન ઇકોનોમિક એરિયા, યુનાઈટેડ કિંગડમ અને વૈશ્વિક સ્તરે વ્યક્તિઓને તેમની વ્યક્તિગત માહિતી અંગે અમુક કાયદાકીય અધિકારો હોઈ શકે છે. ઉદાહરણ તરીકે, તમારી પાસે નીચેના અધિકારો હોઈ શકે છે:',
    block9:
      'સેવામાં નોમ દ્વારા સંચાલિત અથવા નિયંત્રિત ન હોય તેવી અન્ય વેબસાઈટ્સના લિંક્સ હોઈ શકે છે, જેમાં સોશિયલ મીડિયા સેવાઓ ("તૃતીય પક્ષ વેબસાઈટ્સ")નો સમાવેશ થાય છે. તમે તૃતીય પક્ષ વેબસાઈટ્સ સાથે શેર કરો તે માહિતી તૃતીય પક્ષ વેબસાઈટ્સની ચોક્કસ ગોપનીયતા નીતિઓ અને સેવાની શરતો દ્વારા સંચાલિત થશે, આ ગોપનીયતા નીતિ દ્વારા નહીં. અમે આ લિંક્સ સુવિધા માટે પ્રદાન કરીએ છીએ અને આ વેબસાઈટ્સની અમારી સમર્થન અથવા સમીક્ષાનો સૂચન કરતા નથી. તેમની ગોપનીયતા નીતિઓ અને શરતો વિશે માહિતી માટે કૃપા કરીને તૃતીય પક્ષ વેબસાઈટ્સ સાથે સીધے સંપર્ક કરો. ',
    subBlock1:
      'ખાતું માહિતી: જ્યારે તમે અમારા પ્લેટફોર્મ પર એક ખાતું બનાવો છો, ત્યારે અમે તમારા ખાતા સાથે સંબંધિત માહિતી એકત્રિત કરીએ છીએ, જેમાં તમારું નામ, સંપર્ક માહિતી, ખાતા ક્રેડેન્શિયલ્સ, પેમેન્ટ કાર્ડ માહિતી અને વ્યવહાર ઇતિહાસ ("ખાતું માહિતી")નો સમાવેશ થાય છે.',
    subBlock10: 'સેવાઓ પ્રદાન કરવી, સંચાલિત કરવી, જાળવવી અને/અથવા વિશ્લેષણ કરવી;',
    subBlock11: 'તમારી સાથે સંચાર કરતા',
    subBlock12: 'નવા પ્રોડક્ટ્સ અને સર્વિસિસ વિકસાવવું;',
    subBlock13:
      'અનુપાલન, ગુનાહિત પ્રવૃત્તિ અથવા અમારી સેવાઓના દુરુપયોગને અટકાવવા, અને અમારી IT સિસ્ટમ્સ, આર્કિટેક્ચર અને નેટવર્કની સુરક્ષાને બચાવવા;',
    subBlock14: 'વ્યવસાય ટ્રાન્સફર કરવું;',
    subBlock15:
      'કાનૂની જવાબદારીઓ અને કાનૂની પ્રક્રિયાઓનું પાલન કરવું, અમારા અધિકારો, ગોપનીયતા, સુરક્ષા અથવા સંપત્તિનું સંરક્ષણ કરવું, તેમજ અમારા સહયોગકો, તમારા અથવા અન્ય તૃતીય પક્ષોના.',
    subBlock16:
      'સપ્લાયર્સ અને સર્વિસ પ્રોવાઇડર્સ: વ્યવસાયની ઓપરેશનલ જરૂરિયાતોને પૂરી કરવા અને અમુક સેવાઓ અને કાર્યો કરવામાં અમને મદદ કરવા માટે, અમે સપ્લાયર્સ અને સર્વિસ પ્રોવાઇડર્સને વ્યક્તિગત માહિતી પ્રદાન કરી શકીએ છીએ, જેમાં હોસ્ટિંગ સર્વિસ પ્રોવાઇડર્સ, ક્લાઉડ સર્વિસ પ્રોવાઇડર્સ, અને અન્ય માહિતી તકનીકી સર્વિસ પ્રોવાઇડર્સ, ઇમેઇલ કોમ્યુનિકેશન સોફ્ટવેર, અને વેબ એનાલિટિક્સ સર્વિસ પ્રોવાઇડર્સ વગેરાંનો સમાવેશ થાય છે. આ પાર્ટનરો અમારા માટે તેમની ફરજો કરવા વખતે ફક્ત અમારી દિશામાં વ્યક્તિગત માહિતીને ઍક્સેસ, પ્રોસેસ અથવા સ્ટોર કરશે.',
    subBlock17:
      'બિઝનેસ ટ્રાન્સફર્સ: જો આપણે વ્યૂહાત્મક লেনदেনો, પુનઃસંગઠનો, દેવુંદારીયતા, દેવુંદારી ટેકઓવર્સ અથવા સેવાઓને બીજા પ્રદાતા તરફ સ્થાનાંતરિત કરીએ છીએ (એકસાથે "લেনદেনો"), તો તમારી વ્યક્તिगત માહિતી અને અન્ય માહિતી નિરીક્ષણ દરમિયાન લেনદાનના પક્ષો અને લেনદાનમાં મદદ કરતા અન્ય પક્ષો સાથે શેર કરી શકાય છે અને અન્ય સંપત્તિઓ સાથે સફળકાર અથવા સહયોગક કંપનીને લেনદાનના ભાગ રૂપે સ્થાનાંતરિત કરી શકાય છે.',
    subBlock18:
      'કાનૂની આવશ્યકતાઓ: અમે તમારી વ્યક્તિગત માહિતીને સરકારી સત્તાઓ, ઉદ્યોગ સાથીઓ અથવા અન્ય તૃતીય પક્ષો સાથે શેર કરી શકીએ છીએ, જેમાં તમારી અમારી સેવાઓ સાથેની ક્રિયાપ્રતિક્રિયા માહિતીનો સમાવેશ થાય છે, (1) જો કાયદા દ્વારા જરૂરી હોય અથવા અમને લાગે કે કાનૂની બંધનો પાલન કરવા માટે આવી ક્રિયા જરૂરી છે; (2) અમારા અધિકારો અથવા સંપત્તિનું રક્ષણ અને બચાવ કરવા માટે; (3) જો અમે એકપક્ષી રીતે નિર્ધારિત કરીએ કે અમારી શરતો, નીતિઓ અથવા કાયદાઓનું ઉલ્લંઘન થયું છે; (4) છેતરપણું અથવા અન્ય ગેરકાનૂની પ્રવૃત્તિઓને શોધવા અથવા અટકાવવા માટે; (5) અમારા પ્રોડક્ટ્સ, કર્મચારીઓ અથવા વપરાશકર્તાઓ અથવા સાર્વજનિક સલામતી, સુરક્ષા, અખંડતાનું રક્ષણ કરવા માટે; અથવા (vi) કાનૂની જવાબદારીની વિરુદ્ધ બચાવ કરવા માટે.',
    subBlock19:
      'તમારી વ્યક્તિગત માહિતી અને તેની પ્રક્રિયા કેવી રીતે કરવામાં આવે છે તે વિશેની માહિતીに ઍક્સેસ કરો.',
    subBlock2:
      'જ્યારે તમે અમારી સેવાઓનો ઉપયોગ કરો છો, ત્યારે અમે તમારા ઇનપુટ્સ, ફાઇલ અપલોડ્સ અથવા અમને આપવામાં આવેલ ફીડબેક ("કન્ટેન્ટ")માંથી વ્યક્તિગત માહિતી એકત્રિત કરીએ છીએ.',
    subBlock20: 'અમારા રેકોર્ડ્સમાંથી તમારી વ્યક્તિગત માહિતીને કાઢી નાખવાની વિનંતી કરો.',
    subBlock21: 'તમારી વ્યક્તિગત માહિતીને સુધારો અથવા અપડેટ કરો.',
    subBlock22: 'તમારી વ્યક્તિગત માહિતીને તૃતીય પક્ષને ટ્રાન્સફર કરો (ડેટા પોર્ટેબિલિટી).',
    subBlock23: 'તમારી વ્યક્તિગત માહિતીની પ્રક્રિયા કેવી રીતે કરવી તેને મર્યાદિત કરો.',
    subBlock24:
      'તમારી સંમતિ પાછી ખેંચો—જ્યાં આપણે પ્રક્રિયા કરવાના કાનૂની આધાર તરીકે સંમતિ પર આધાર રાખીએ છીએ, ત્યાં તમે કોઈપણ સમયે તમારી સંમતિ પાછી ખેંચી શકો છો. ',
    subBlock25: 'અમે તમારી વ્યક્તિગત માહિતીની પ્રક્રિયા કેવી રીતે કરીએ છીએ તેના સામે વાંધો ઉઠાવો.',
    subBlock26: 'અમારી સેવાઓને સુધારવું અને સંશોધન કરાવવું;',
    subBlock3:
      'સંચાર માહિતી: જો તમે અમને સંદેશા મોકલો છો, તો અમે તમારું નામ, સંપર્ક માહિતી અને તમારા સંદેશાઓની સામગ્રી ("સંચાર માહિતી") એકત્રિત કરીશું.',
    subBlock4:
      'સોશિયલ મીડિયા માહિતી: અમારી પાસે ઇન્સ્ટાગ્રામ, ફેસબુક, મીડિયમ, ટ્વિટર, YouTube અને LinkedIn જેવી સોશિયલ મીડિયા વેબસાઈટ્સ પર પૃષ્ઠો છે. જ્યારે તમે અમારા સોશિયલ મીડિયા પૃષ્ઠો સાથે ક્રિયાપ્રતિક્રિયા કરો છો, ત્યારે અમે તમારી વ્યક્તિગત માહિતી એકત્રિત કરીએ છીએ જે તમે અમને પ્રદાન કરવાનું પસંદ કરો છો, જેમ કે તમારી સંપર્ક વિગતો ("સોશિયલ માહિતી"). ઉપરાંત, અમારા સોશિયલ મીડિયા પૃષ્ઠોને હોસ્ટ કરતી કંપનીઓ અમને અમારી સોશિયલ મીડિયા પ્રવૃત્તિઓ વિશે એકત્રિત માહિતી અને વિશ્લેષણ પ્રદાન કરી શકે છે. ',
    subBlock5:
      'લોગ ડેટા: અમારી સેવાઓનો ઉપયોગ કરતી વખતે તમારા બ્રાઉઝર દ્વારા સ્વચાલિત રીતે મોકલવામાં આવતી માહિતી. લોગ ડેટામાં તમારું ઇન્ટરનેટ પ્રોટોકોલ (IP) એડ્રેસ, બ્રાઉઝર પ્રકાર અને સેટિંગ્સ, તમારી વિનંતીઓની તારીખ અને સમય, અને તમે અમારી વેબસાઈટ સાથે કેવી રીતે ક્રિયાપ્રતિક્રિયા કરો છો તેનો સમાવેશ થાય છે.',
    subBlock6:
      'વપરાશ ડેટા: અમે સેવાના તમારા ઉપયોગ વિશે આપમેળે માહિતી એકત્રિત કરી શકીએ છીએ, જેમ કે તમે જે સામગ્રીના પ્રકારોને જુઓ છો અથવા સાથે ક્રિયાપ્રતિક્રિયા કરો છો, તમે જે સુવિધાઓનો ઉપયોગ કરો છો, તમે જે ક્રિયાઓ કરો છો, તેમજ તમારો સમય ઝોન, દેશ, ઍક્સેસની તારીખ અને સમય, યુઝર એજન્ટ અને સંસ્કરણ, કોમ્પ્યુટર અથવા મોબાઈલ ડિવાઇસ પ્રકાર, અને તમારું કોમ્પ્યુટર કનેક્શન.',
    subBlock7:
      'ડિવાઇસ માહિતી: આમાં ડિવાઇસનું નામ, ઓપરેટિંગ સિસ્ટમ, ડિવાઇસ ઓળખકર્તા અને તમે ઉપયોગ કરતા બ્રાઉઝરનો સમાવેશ થાય છે. એકત્ર કરેલ માહિતી તમે ઉપયોગ કરતા ડિવાઇસના પ્રકાર અને તેના સેટિંગ્સ પર આધાર રાખે છે.',
    subBlock8:
      'કૂકી: અમે અમારી સેવાઓ ચલાવવા અને સંચાલિત કરવા અને તમારા અનુભવને સુધારવા માટે કૂકીનો ઉપયોગ કરીએ છીએ. "કૂકી" એ તમે મુલાકાત લેતા વેબસાઇટ દ્વારા તમારા બ્રાઉઝરને મોકલી गई માહિતી છે. તમે તમારા બ્રાઉઝરને તમામ કૂકી સ્વીકારવા, તમામ કૂકી નકારવા અથવા કૂકી પ્રદાન કરવામાં આવે ત્યારે તમને સૂચિત કરવા માટે સેટ કરી શકો છો જેથી તમે દર વખતે તેને સ્વીકારવું કે કેમ તે નક્કી કરી શકો. જો કે, કૂકીને નકારવાથી તમે વેબસાઇટના કેટલાક વિસ્તારો અથવા સુવિધાઓનો ઉપયોગ કરવામાં અસમર્થ થઈ શકો છો અથવા તેના પ્રદર્શન અથવા કાર્યક્ષમતાને નકારાત્મક અસર પહોંચાડી શકો છો. કૂકી વિશે વધુ માહિતી માટે, કૃપા કરીને All About Cookies પર મુલાકાત લો.',
    subBlock9:
      'એનાલિટિક્સ: અમે કૂકીઝનો ઉપયોગ કરતા વિવિધ ઓનલાઈન એનાલિટિક્સ પ્રોડક્ટ્સનો ઉપયોગ કરી શકીએ છીએ જે વપરાશકર્તાઓ કેવી રીતે અમારી સેવાઓનો ઉપયોગ કરે છે તેનું વિશ્લેષણ કરવામાં અમને મદદ કરે છે અને સેવાઓનો ઉપયોગ કરતી વખતે તમારો અનુભવ સુધારે છે.',
    subTitle1: 'અમે એકત્રિત કરતા વ્યક્તિગત માહિતી',
    subTitle2: 'અમે વ્યક્તિગત માહિતીનો ઉપયોગ કેવી રીતે કરીએ છીએ',
    subTitle3: 'વ્યક્તિગત માહિતીનું પ્રકાશન',
    subTitle4: 'તમારા અધિકારો',
    subTitle5: 'અન્ય વેબસાઇટ્સની લિંક્સ',
    subTitle6: 'માહિતીની સુરક્ષા અને જાળવણી',
    subTitle7: 'ગોપનીયતા નીતિનું ફેરફાર',
    subTitle8: 'અમારો સંપર્ક કેવી રીતે કરવો',
    title: 'ગોપનીયતા નીતિ',
    updateTime: 'અપડેટ કર્યું: 15 માર્ચ, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'બધું સ્વીકારો',
    text: 'તમારા અનુભવને સુધારવા માટે, અમે સામગ્રી અને સેવાઓને વ્યક્તિગત બનાવવા માટે કૂકીઝનો ઉપયોગ કરીએ છીએ.',
    title: 'આ વેબસાઇટ કુકીઝનો ઉપયોગ કરે છે',
  },
  slogen: 'સૌથી સરળ AI સહાયક',
  stripe: {
    contact: 'કોઈપણ પ્રશ્નો હોય તો contact@noam.tools પર અમારો સંપર્ક કરો!',
    fail: {
      btn: 'પુનઃ પ્રયાસ કરો',
      text1: 'તમારી પેમેન્ટ પ્રોસેસ કરી શક્યા નહીં.',
      text2: 'તમારું કનેક્શન ચકાસો અને ફરીથી પ્રયાસ કરો. ',
      title: 'પેમેન્ટ નિષ્ફળ',
    },
    succ: {
      btn: 'ચાલો જઈએ',
      text1: 'નોઅમનું સ્વાગત છે',
      text2: 'ચાલો શરૂ કરીએ!',
      title: 'અભિનંદન',
    },
  },
  terms: {
    block1: 'નોમ વાપરવા બદલ આભાર!',
    block10:
      'ફીસ અને બિલિંગ. તમે લાગુ કિંમત પૃષ્ઠ પરના કિંમત અને શરતો અનુસાર અથવા અમારી વચ્ચે લેખિતમાં સંમત કર્યા પ્રમાણે તમે તમામ ફીસ ("ફીસ") ચૂકવશો. અમે કિંમતની ભૂલો અથવા ભૂલો સુધારવાનો અધિકાર સંરક્ષિત રાખીએ છીએ, ભલે અમે ઇનવોઇસ જારી કરી હોય અથવા પેમેન્ટ પ્રાપ્ત કરી હોય. તમે સંપૂર્ણ અને સચોટ બિલિંગ માહિતી પ્રદાન કરશો, જેમાં માન્ય અને અધિકૃત પેમેન્ટ પદ્ધતિ શામેલ છે. અમે સંમત પ્રમાણે તમારી પેમેન્ટ પદ્ધતિ પર સામયિક ધોરણે ચાર્જ કરીશું, પરંતુ અમે બિલિંગ તારીખ વ્યાજબી રીતે બદલી શકીએ છીએ. તમે નોઅમ, તેની સહયોગક કંપનીઓ અને તૃતીય પક્ષ પેમેન્ટ પ્રોસેસરોને તમારી પેમેન્ટ પદ્ધતિ પર ચાર્જ કરવાનું અધિકૃત કરો છો. જો તમારું પેમેન્ટ નિષ્ફળ જાય, તો અમે તમને લેખિત નોટિસ પ્રદાન કરીશું અને પેમેન્ટ પ્રાપ્ત ન થાય ત્યાં સુધી સર્વિસની ઍક્સેસ સસ્પેન્ડ કરી શકીએ છીએ. આ કરારમાં અન્યથા નિર્દિષ્ટ ન હોય ત્યાં સિવાય, પેમેન્ટ્સ પ્રત્યારોપી નથી. ',
    block11:
      '(b) कर. અન્યथા સ્પષ્ટ કરা ન હોય ત્યાં સુધી, ફીમાં કોઈપણ ફેડરલ, રાજ્ય, સ્થાનિક અને વિદેશી કર, ડ્યુટી અને સમાન આકારણીઓ ("કર") સામેલ નથી. તમારી ખરીદી સાથે સંકળાયેલા તમામ કરની જવાબદારી તમારી છે, અમારી નેટ આવક પર આધારિત કર સિવાય કે જેના માટે અમે તમને ઇન્વોઈસ આપીશું. તમે આવા કરોનો તરત જ ચુકવણી કરવા અને અમને કાયદેસર રીતે માન્ય ગોપનીયતા નિવેદનો પ્રદાન કરવા અને આવા ડેટાને હેન્ડલ કરવા માટે જરૂરી સંમતિઓ મેળવવા સંમત છો, અને તમે અમને વોરંટ આપો છો કે તમે એવા ડેટાને લાગુ કાયદા અનુસાર હેન્ડલ કરો છો.',
    block12:
      '(c) ભાવ ફેરફારો. અમે તમારા એકાઉન્ટ અને/અથવા અમારી વેબસાઇટ દ્વારા તમને સૂચના આપીને અમારા ભાવો બદલી શકીએ છીએ. ભાવ વધારો પોસ્ટ થતાં તરત જ અસરકારક થશે. કોઈપણ ભાવ ફેરફાર ફેરફારની અસરકારક તારીખ પછી તમારા એકાઉન્ટ માટેના ફીસ પર લાગુ થશે.',
    block13:
      '(ડી) વિવાદો અને વળતર ચુકવણીઓ. જો તમે કોઈ ફી અથવા કરનો વિવાદ કરવા ઈચ્છો છો, તો કૃપા કરીને ઇન્વોઇસ તારીખના ત્રીસ (30) દિવસની અંદર contact@noam.tools સાથે સંપર્ક કરો. ',
    block14:
      'મફત ઉપયોગ. તમે મફત ક્રેડિટ મેળવવા માટે બહુવિધ એકાઉન્ટ્સ બનાવી શકશો નહીં. જો અમે નિર્ધારિત કરીએ કે તમે સ્પષ્ટ નિષ્ઠાથી મફત ક્રેડિટનો ઉપયોગ કરી રહ્યા નથી, તો અમે તમને પ્રમાણભૂત ફીસ લઈ શકીએ છીએ અથવા સર્વિસની ઍક્સેસ પ્રદાન કરવાનું બંધ કરી શકીએ છીએ.',
    block15:
      'ગોપનીયતા. તમારી પાસે નોમની ગોપનીય માહિતી доступ હોઈ શકે છે. સેવાનો ઉપયોગ કરવાના હેતુ માટે તમે ફક્ત આ શરતો હેઠળ મંજૂર કરાયેલી ગોપનીય માહિતીનો ઉપયોગ કરી શકો છો. તમે ગોપનીય માહિતીને કોઈપણ તૃતીય પક્ષને પ્રકાશિત કરી શકશો નહીં, અને તમે તમારી પોતાની સમાન ગોપનીય માહિતીનું રક્ષણ કરતા ઓછામાં ઓછું રક્ષણકારી રીતે ગોપનીય માહિતીનું રક્ષણ કરશો, ઓછામાં ઓછું વ્યવસ્થિત સાવચેતી સાથે. ગોપનીય માહિતી એ બિન-સાર્વજનિક માહિતી છે જેને નોમ દ્વારા ગોપનીય તરીકે નિર્દિષ્ટ કરવામાં આવે છે અથવા જે સંજોગોમાં ગોપનીય તરીકે વ્યવસ્થિત રીતે ગણવામાં આવે છે, જેમાં સોફ્ટવેર, સ્પષ્ટીકરણો અને અન્ય બિન-સાર્વજનિક વ્યવસાય માહિતી શામેલ છે. ગોપનીય માહિતીમાં નીચેની માહિતી શામેલ નથી: (1) તમારી ભૂલ વિના સામાન્ય રીતે જનતા માટે ઉપલબ્ધ થાય છે; (2) તમારી પાસે આ શરતો હેઠળ પ્રાપ્ત કરતા પહેલા ગોપનીયતાની કોઈ જવાબદારી વિના હતી; (3) કોઈ તૃતીય પક્ષ દ્વારા ગોપનીયતાની કોઈ જવાબદારી વિના કાયદેસર રીતે તમને પ્રકાશિત કરવામાં આવે છે; અથવા (4) તમે ગોપનીય માહિતીનો ઉપયોગ કર્યા વિના સ્વતંત્ર રીતે વિકસાવી છે. જો કાયદા, કોર્ટ અથવા અન્ય સરકારી આદેશ દ્વારા જરૂરી હોય તો તમે ગોપનીય માહિતીનું પ્રકાશન કરી શકો છો, પરંતુ તમારે નોમને વ્યવસ્થિત રીતે પ્રાધાનિક લેખીય સૂચના આપવી આવશ્યક છે અને શક્ય તેટલા અધિકાર સુધી, પ્રકાશનની સીમાને મર્યાદિત કરવા માટે વ્યવસ્થિત પ્રયત્નો કરશો, જેમાં પ્રકાશન વિનંતીઓનો વિરોધ કરવામાં અમને મદદ કરવાનો સમાવેશ થાય છે.',
    block16:
      '(બ) સુરક્ષા. સર્વિસની તમારી ઍક્સેસ અને ઉપયોગને સુરક્ષિત રાખવા માટે તમારે વાજબી અને યોગ્ય પગલાં લેવા જોઈએ. જો તમે સર્વિસના તમારા ઉપયોગ સાથે સંબંધિત કોઈ કમજોરી અથવા ઉલ્લંઘન શોધો છો, તો તમારે તરત જ નોઅમનો સંપર્ક કરવો જોઈએ અને કમજોરી અથવા ઉલ્લંઘનની વિગતો પ્રદાન કરવી જોઈએ.',
    block17:
      '(c) વ્યક્તિગત ડેટાની પ્રક્રિયા. જો તમે વ્યક્તિગત ડેટાની પ્રક્રિયા કરવા સેવાનો ઉપયોગ કરો છો, તો તમારે કાયદેસર રીતે પૂરતા ગોપનીયતા નિવેદનો પ્રદાન કરવા અને આવા ડેટાની પ્રક્રિયા કરવા માટે જરૂરી સંમતિ મેળવવી આવશ્યક છે, અને તમે અમને ضمانું આપો છો કે તમે લાગુ કાયદાના અનુસાર આવા ડેટાનું સંચાલન કરો છો.',
    block18:
      '(a) સમાપ્તિ; સસ્પેન્શન. આ શરતો સેવાના તમારા પ્રથમ ઉપયોગથી અસરકારક થશે અને સમાપ્ત ન થાય ત્યાં સુધી અસરકારક રહેશે. સેવા અને સામગ્રીનો ઉપયોગ બંધ કરીને તમે કોઈપણ કારણસાથે કોઈપણ સમયે આ શરતો સમાપ્ત કરી શકો છો. અમે કોઈપણ કારણસાથે પૂર્વ સૂચના સાથે આ શરતો સમાપ્ત કરી શકીએ છીએ. જો તમે વિભાગ 2 (ઉપયોગ જરૂરીતાઓ), વિભાગ 5 (ગોપનीयતા, સુરક્ષા અને ડેટા સુરક્ષા), વિભાગ 8 (વિવાદ નિરાકરણ) અથવા વિભાગ 9 (સામાન્ય શરતો)નું ભારે ભંગ કરો છો, અથવા જો અમારા નિયંત્રણની બહારના કોઈ તૃતીય પક્ષ તકનીકી પ્રદાતા સાથેનો અમારો સંબંધ બદલાય છે, અથવા કાયદા અથવા સરકારી વિનંતીઓનું પાલન કરવા ਲਈ અમે તમને સૂચના આપીને આ શરતો તરત જ સમાપ્ત કરી શકીએ છીએ. જો તમે આ શરતો અનુસરતા ન હોવ, અથવા જો તમારો ઉપયોગ અમારા અથવા કોઈ તૃતીય પક્ષને સુરક્ષા જોખમ પેદા કરે છે, અથવા જો અમે તમારા ઉપયોગને છેતરપિંડી અથવા અમારા અથવા કોઈ તૃતીય પક્ષને જવાબદારીમાં મૂકી શકે તેવી શંકા હોય તો અમે સેવાની તમારી ઍક્સેસને સસ્પેન્ડ કરી શકીએ છીએ.',
    block19:
      '(બ) સમાપ્તિની અસરો. સમાપ્તિ પર, તમે સર્વિસનો ઉપયોગ બંધ કરશો અને અમારી દિશા অনુસાર તરત જ કોઈપણ ગોપનીય માહિતી પરત કરશો અથવા નાશ કરશો. આ શરતોની જે જોગવાઈઓ તેમના સ્વભાવ દ્વારા સમાપ્તિ અથવા સમયગાળાની સમાપ્તિ પછી પણ ટકી રહેવી જોઈએ, જેમાં સેક્શન 3 અને 5-9નો સમાવેશ થાય છે પરંતુ તેનાથી મર્યાદિત નથી, તે ટકી રહેશે.',
    block2:
      'નોમની સેવાઓના તમારા ઉપયોગ પર આ વપરાશ શરતો લાગુ પડે છે, જેમાં અમારા એપ્લિકેશન પ્રોગ્રામિંગ ઇન્ટરફેસ, સોફ્ટવેર, ટૂલ્સ, ડેવલપર સેવાઓ, ડેટા, દસ્તાવેજીકરણ અને વેબસાઇટ (સમૂહીકરીને "સેવાઓ" તરીકે ઓળખાય છે)નો સમાવેશ થાય છે. અમારી સેવાઓનો ઉપયોગ કરીને, તમે આ શરતો પર પાલન کرنے સંમત થાઓ છો. અમારી ગોપનીયતા નીતિ સમજાવે છે કે અમે વ્યક્તિગત માહિતી કેવી રીતે એકત્રિત કરીએ છીએ અને ઉપયોગ કરીએ છીએ.',
    block20:
      'ભરપાઈ. સર્વિસના તમારા ઉપયોગથી ઉદ્દભવતા અથવા તેનાથી સંબંધિત કોઈપણ દાવાઓ, નુકસાનો અને ખર્ચો (એટર્ની ફીસ સહિત), જેમાં તમારું સામગ્રી, સર્વિસ સાથે સંબંધિત પ્રોડક્ટ્સ અથવા સર્વિસનો તમારો ઉપયોગ, અને આ શરતો અથવા લાગુ કાયદાનું તમારું ઉલ્લંઘન શામેલ છે, તેના સામે અમને, અમારા સહયોગકોને, અને અમારા કર્મચારીઓને તમે બચાવશો, ભરપાઈ કરશો અને હારmless રાખશો.',
    block21:
      '(બ) અસ્વીકારો. સર્વિસ "જેમ છે તેમ" પ્રદાન કરવામાં આવે છે. કાયદા દ્વારા પરવાનગી આપવામાં આવેલી હદ સુધી, અમે અને અમારા સંયોજકો અને લાઇસન્સર્સ સર્વિસ અંગે કોઈપણ પ્રકારના પ્રતિનિધિત્વ અથવા વોરંટી આપતા નથી અને કોઈ વોરંટી આપતા નથી, જેમાં સામેલ છે પરંતુ મર્ચન્ટેબિલિટીની વોરંટી, ચોક્કસ હેતુ માટે ફિટનેસ, સંતોષકારક ગુણવત્તા, બિન-ઇન્ફ્રિંજમેન્ટ અને શાંત આનંદની વોરંટી સહિત, અને વ્યવહારના કોર્સ અથવા વેપારના ઉપયોગમાંથી ઉદ્ભવતી કોઈપણ વોરંટી. અમે વોરંટી આપતા નથી કે સર્વિસ અવિરત, સચોટ અથવા ભૂલ-રહિત રહેશે, અથવા કોઈ કન્ટેન્ટ સુરક્ષિત રહેશે, ખોવાઈશ નહીં અથવા બદલવામાં નહીં આવશે.',
    block22:
      '(c) જવાબદારીની મર્યાદા. અમે, અમારા સહયોગી સంస્થાઓ અથવા અમારા લાઇસન્સર્સ કોઈપણ પરોક્ષ, આકસ્મિક, વિશેષ, પરિણામી અથવા સજાવટી નુકસાન માટે જવાબદાર રહેશે નહીં, જેમાં નફાનું નુકસાન, પ્રતિષ્ઠાનું નુકસાન, ઉપયોગનું નુકસાન, ડેટાનું નુકસાન અથવા અન્ય અમૂર્ત નુકસાન શામેલ છે, ભલે અમને આવા નુકસાનની સંભાવના વિશે સૂચિત કરવામાં આવ્યું હોય. આ શરતો હેઠળ, અમારી કુલ જવાબદારી દાવાની પૂર્વ十二 (12) મહિનામાં તમે સર્વિસને ચૂકવેલા ફીસ અથવા સો યુએસ ડોલર ($100) ની વત્તા માંથી કોઈપણ વધારાનું હશે નહીં. આ વિભાગની મર્યાદાઓ લાગુ કાયદા દ્વારા પરવાનગી આપવામાં આવતી મહત્તમ હદ સુધી લાગુ પડે છે.',
    block23:
      'શરતો અને સેવાઓના તમારા ઉપયોગનું સંચાલન યુનાઇટેડ સ્ટેટ્સના કાયદા દ્વારા થાય છે, સિવાય કે યુ.એસ. કન્ફ્લિક્ટ ઓફ લો સૂત્રોના. એપ્લિકેશનનો તમારો ઉપયોગ અન્ય સ્થાનિક, રાજ્ય, રાષ્ટ્રીય અથવા આંતરરાષ્ટ્રીય કાયદાને પણ આધીન હોઈ શકે છે. આ શરતો સાથે સંબંધિત કોઈપણ કાનૂની ક્રિયા અથવા કાર્યવાહી ફક્ત યુનાઇટેડ સ્ટેટ્સની અદાલતોમાં કરવામાં આવશે, અને તમે આવી અદાલતોના વ્યક્તિગત અધિકારક્ષેત્રમાં સબમિટ કરવા સંમત છો. ',
    block24:
      'પક્ષોનો સંબંધ. નોએમ અને તમે સ્વતંત્ર કોન્ટ્રાક્ટર છો, અને બીજા પક્ષની પહેલા લેખિત સંમતિ વિના કોઈપણ પક્ષની બીજા પક્ષનું પ્રતિનિધિત્વ કરવાની અથવા બાંધવાની કે બીજા પક્ષ માટે જવાબદારીઓ સ્વીકારવાની ક્ષમતા નથી.',
    block25:
      '(b) બ્રાન્ડ વપરાશ. અમારી પૂર્વ લેખિત સંમતિ વિના તમે નોમ અથવા તેના કોઈ પણ સહયોગી સంస્થાઓનું નામ, લોગો અથવા ટ્રેડમાર્ક વાપરી શકશો નહીં.',
    block26:
      'જો આ શરતોની કોઈ કલમ અમાન્ય, ગેરકાયદેસર અથવા અકાર્યક્ષમ હોવાનું નક્કી કરવામાં આવે તો, બાકીની કલમો સંપૂર્ણ બળ અને અસરમાં રહેશે.',
    block3:
      'જો તમે 18 વર્ષથી નીચા છો, તો સર્વિસનો ઉપયોગ કરવા માટે તમારા માતાપિતા અથવા કાયદેસર કાર્યવાહકો પાસેથી પરવાનગી લેવી આવશ્યક છે. જો તમે કોઈ અન્ય વ્યક્તિ અથવા સંસ્થાની તરફથી સર્વિસનો ઉપયોગ કરી રહ્યા છો, તો તમારી તરફથી આ શરતોને સ્વીકારવા માટે તમારે અધિકૃત હોવું આવશ્યક છે. એકાઉન્ટ રજિસ્ટર કરવા માટે તમારે સચોટ અને સંપૂર્ણ માહિતી પ્રદાન કરવી આવશ્યક છે. તમે તમારી સંસ્થાની બહારના કોઈને તમારી એક્સેસ ક્રેડેન્શિયલ્સ અથવા એકાઉન્ટ પ્રદાન કરી શકશો નહીં, અને તમારી ક્રેડેન્શિયલ્સનો ઉપયોગ કરીને કરવામાં આવતી તમામ પ્રવૃત્તિઓના માટે તમે જવાબદાર છો.',
    block4:
      '(a) સર્વિસનો ઉપયોગ. તમે આ શરતો હેઠળ સર્વિસને ઍક્સેસ કરી શકો છો, અને અમે તમને સર્વિસનો ઉપયોગ કરવાનો બિન-વિશિષ્ટ अधિકાર આપીએ છીએ. સર્વિસનો ઉપયોગ કરતી વખતે, તમે આ શરતો અને તમામ લાગુ કાયદાઓનું પાલન કરશો. અમે અને અમારા સહયોગી સર્વિસમાં તમામ હકકો, શીર્ષકો અને હિતો ધરાવે છે. ',
    block5:
      'ફીડબેક. અમે ફીડબેક, ટિપ્પણીઓ, વિચારો, સૂચનાઓ અને સુધારાઓનું સ્વાગત કરીએ છીએ. જો તમે આવી કોઈ સામગ્રી પ્રદાન કરો છો, તો અમે તેનો કોઈપણ પ્રતિબંધ વિના અને તમને કોઈ વળતર વિના ઉપયોગ કરી શકીએ છીએ.',
    block6:
      '(c) પ્રતિબંધો. તમે ન કરી શકશો: (1) સેવાનો ઉપયોગ એવી રીતે કરો કે જે અન્ય લોકોના કોઈપણ અધિકારોનું ઉલ્લંઘન કરે, અપropriેટ કરે અથવા તેનું ઉલ્લંઘન કરે; (2) રિવર્સ એન્જિનિયરિંગ, ડીકોમ્પાઇલ, ડિસએસેમ્બલ, અનુવાદ અથવા અન્યથા સેવાના મોડલ્સ, અલ્ગોરિધમ્સ અને સિસ્ટમ્સના સોર્સ કોડ અથવા અંતર્ગત ઘટકોને શોધવાનો પ્રયાસ કરો (જ્યાં સુધી એવા પ્રતિબંધો લાગુ કાયદા દ્વારા પ્રતિબંધિત નથી); (3) નોમ સાથે સ્પર્ધા કરતા મોડલ્સ વિકસાવવા માટે સેવાના આઉટપુટનો ઉપયોગ કરો; (4) API દ્વારા அனુમતિ આપવામાં આવ્યા સિવાય કોઈપણ સ્વચાલિત અથવા પ્રોગ્રામિંગ પદ્ધતિઓનો ઉપયોગ કરીને સેવામાંથી ડેટા અથવા આઉટપુટ બહાર કાઢો, જેમાં સ્ક્રેપિંગ, વેબ હાર્વેસ્ટિંગ અથવા વેબ ડેટા એક્સ્ટ્રેક્શનનો સમાવેશ થાય છે; (5) સેવાના આઉટપુટને કૃત્રિમ રીતે જનરેટેડ તરીકે રજૂ કરો જ્યારે તે નથી, અથવા અન્યથા અમારી ઉપયોગ નીતિઓનું ઉલ્લંઘન કરો; (6) અમારી પ્રારંભિક સંમતિ વિના API કી ખરીદો, વેચો અથવા ટ્રાન્સફર કરો; અથવા (7) અમને 13 વર્ષથી ઓછી ઉંમરના બાળકો અથવા ડિજિટલ સંમતિની લાગુ ઉંમરની કોઈપણ વ્યક્તિગત માહિતી પ્રદાન કરો. તમે અમારા દસ્તાવેજીકરણમાંની કોઈપણ રેટ લિમિટ્સ અને અન્ય આવશ્યકતાઓનું પાલન કરશો. ',
    block7:
      '(d) તૃતીય-પક્ષ સેવાઓ. સેવા સાથે સંકળાયેલ કોઈપણ તૃતીય-પક્ષ સોફ્ટવેર, સેવાઓ અથવા અન્ય પ્રોડક્ટ્સ તેમની પોતાની શરતો દ્વારા સંચાલિત થાય છે, અને તૃતીય-પક્ષ પ્રોડક્ટ્સ માટે અમે જવાબદાર નથી.',
    block8:
      'તમારું સામગ્રી. તમે સર્વિસને ઇનપુટ ("ઇનપુટ") પ્રદાન કરી શકો છો અને ઇનપુટના આધારે જનરેટ અને પ્રત્યાર્પિત આઉટપુટ ("આઉટપુટ") પ્રાપ્ત કરી શકો છો (સમૂહરૂપે "સામગ્રી" તરીકે ઓળખાય છે). પક્ષો વચ્ચે, અને લાગુ કાયદા દ્વારા મંજૂર હોય ત્યાં સુધી, તમે તમામ ઇનપુટના માલિક છો. નોમ સર્વિસ પ્રદાન કરવા અને જાળવવા, લાગુ કાયદાઓનું પાલન કરવા અને અમારી નીતિઓને લાગુ કરવા માટે સામગ્રીનો ઉપયોગ કરી શકે છે. તમે સામગ્રી માટે જવાબદાર છો, જેમાં તે કોઈપણ લાગુ કાયદા અથવા આ શરતોનું ઉલ્લંઘન કરતું નથી તેની ખાતરી કરવાનો સમાવેશ થાય છે.',
    block9:
      'ચોકસાઈ. કૃત્રિમ બુદ્ધિ અને મશીન લર્નીંગ સંશોધનના ઝડપથી વિકાસશીલ ક્ષેત્રો છે. અમે અમારી સેવાને વધુ ચોકસાઈ, વિશ્વસનીય, સુરક્ષિત અને ફાયદાકારી બનાવવા માટે સતત પ્રયત્ન કરીએ છીએ. મશીન લર્નીંગની સંભાવનાત્મક પ્રકૃતિને જોતાં, અમારી સેવાનો ઉપયોગ અમુક કિસ્સાઓમાં ખોટા આઉટપુટ તરીકે પરિણમી શકે છે, જે વાસ્તવિક વ્યક્તિઓ, સ્થળો અથવા તથ્યોને સચોટ રીતે પ્રતિબિંબિત ન કરી શકે છે. તમારે તમારા ઉપયોગ કેસના આધારે કોઈપણ આઉટપુટની ચોકસાઈનું યોગ્ય મૂલ્યાંકન કરવું જોઈએ, જેમાં કાર્યકર્તા દ્વારા આઉટપુટની સમીક્ષા કરવાનો સમાવેશ થાય છે.',
    subTitle1: 'રજિસ્ટ્રેશન અને ઍક્સેસ',
    subTitle10: 'વિભાજનક્ષમતા',
    subTitle2: 'વપરાશની આવશ્યકતાઓ',
    subTitle3: 'સામગ્રી',
    subTitle4: 'ફી અને પેમેન્ટ',
    subTitle5: 'ગોપનીયતા, સુરક્ષા અને ડેટા સંરક્ષણ',
    subTitle6: 'શરત અને સમાપ્તિ',
    subTitle7: 'ક્ષતિ સુધારણા; અસ્વીકારણ; જવાબદારીની મર્યાદા',
    subTitle8: 'શાસકી કાયદો અને અધિકારક્ષેત્ર',
    subTitle9: 'સામાન્ય શરતો',
    title: 'સેવા શરતો',
    updateTime: 'અપડેટ કર્યું: 15 માર્ચ, 2024',
  },
  trialModal: {
    btn: 'હવે શરૂ કરો（માત્ર $0.99）',
    chat: 'ચેટપીડીએફ',
    desc1: 'તમારા પ્રયત્ન પછી, તમારા પર $180 નું વાર્ષિક ફી ચાર્જ કરવામાં આવશે',
    desc2: 'કોઈપણ સમયે રદ કરો',
    focus: 'કેન્દ્રീകരણ',
    hover: 'હોવર અનુવાદ',
    image: 'ઇમેજ ટ્રાન્સલેશન',
    installBtn: 'તમારો ભેટ મેળવવા હવે ઇન્સ્ટોલ કરો',
    memo: 'પસંદગીનું વ્યવસ્થાપન',
    pdf: 'પીડીએફ સમાંતર અનુવાદ',
    realtime: 'ત્વરિત અનુવાદ',
    select: 'શબ્દ પસંદગીનું અનુવાદ',
    title: 'સ્વાગત ભેટ',
    trialText: '7-દિવસનો પ્રયત્ન',
    video: 'વીડિયો અનુવાદ',
    videoSummary: 'વિડિઓ સારાંશ',
    web: 'સમાંતર અનુવાદ',
    webSummary: 'વેબ સારાંશ',
  },
  upgradeModal: {
    btn: 'હવે અપગ્રેડ કરો',
    chat: {
      free: 'તમે ChatPDF મર્યાદા સુધી પહોંચ્યા છો',
      pro: 'તમે આ મહિનાના ChatPDF મર્યાદા સુધી પહોંચ્યા છો',
    },
    contactStr: 'નીચા રીસેટની પ्रतીક્ષા કરો, અથવા contact@noam.tools પર અમારી સાથે સંપર્ક કરો.',
    limitAlertStr: 'તમારી ફ્રી પ્લાન મર્યાદા પૂરી થઈ ગઈ છે. ચાલુ રાખવા માટે અપગ્રેડ કરો. ',
    more: 'યોજનાઓ જુઓ',
    pageLimit: { free: 'તમે પીડીએફ પૃષ્ઠ મર્યાદા સુધી પહોંચ્યા છો' },
    title: 'નિર્દેશ',
    upgradeAlertStr: 'તમારી ફ્રી પ્લાન લિમિટ પૂરી થઈ ગઈ છે. ચાલુ રાખવા માટે અપગ્રેડ કરો.',
    upload: {
      free: 'તમારી PDF અનુવાદ મર્યાદા પહોંચી ગઈ છે',
      pro: 'તમે આ મહિનાના તમારા PDF અનુવાદ મર્યાદા સુધી પહોંચ્યા છો',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'હવે જોડાઓ',
      label: 'નવા વપરાશકર્તા લાભો:',
      remain: 'માત્ર 30 બાકી છે',
      text: 'માત્ર 100 સ્થાનો ઉપલબ્ધ! હમણાં જ તમારું પકડો!',
    },
  },
  aiPdfTranslator: {
    title: 'ફ્રી AI PDF ટ્રાન્સલેટર: કોઈપણ ભાષામાં તુલના સાથે PDF ટ્રાન્સલેટ કરો',
    desc: 'AI ની મદદથી PDF ફાઇલોને કોઈપણ ભાષામાં સરળતાથી અનુવાદ કરો. મૂળ અને અનુવાદિત ટેક્સ્ટને બાજુબાજુ તুলના કરો, ઝડપી અને મફત.',
    keywords: 'જીપીટી-4、એઆઈ એસિસ્ટન્ટ、ટ્રાન્સલેશન、સમરીસન、ફોકસ、ચેટપીડીએફ、મેમો、કાર્યક્ષમતા',
    sourceToTarget: {
      title: 'ફ્રી પીડીએફ ટ્રાન્સલેશન ટૂલ: {{source}} ને {{target}} માં મફતમાં અનુવાદ કરો',
      desc: 'તમારા PDF ફાઇલોને કોઈપણ સ્ત્રોત ભાષામાંથી તમારી પસંદગીની ભાષામાં મફતમાં અનુવાદ કરો. અદ્યતન AI દ્વારા સંચાલિત ઝડપી, ચોક્કસ અને સુરક્ષિત PDF અનુવાદ.',
    },
    headerIntroduce: {
      title: 'નોએમ: માત્ર ઓનલાઈન અનુવાદથી વધુ',
      introduce1: {
        title: 'નોઅમ · પીડીએફ રીડર',
        desc: '✨સાઇડ-બાય-સાઇડ અનુવાદ + AI પ્રશ્ન-જવાબ. પીડીએફ ફાઇલોને ઝડપથી અને ચોક્કસ રીતે તમારી લક્ષ્ય ભાષામાં અનુવાદ કરો. પીડીએફ ફાઇલોની સામગ્રી વિશે મુક્તપણે પ્રશ્ન પૂછો અને ઊંડી સમજણ મેળવો. ',
      },
      introduce2: {
        title: 'નોઅમ · સાઇડ-બાય-સાઇડ અનુવાદ એક્સ્ટેન્શન',
        desc: '👏તમારી તમામ વેબપેજ ટ્રાન્સલેશન જરૂરિયાતો સોલ્વ કરો:',
        detail1: { title: 'વેબપેજ અનુવાદ:', desc: 'સાઇડ-બાય-સાઇડ બાયલિંગ્વલ દૃશ્ય' },
        detail2: { title: 'શબ્દ અનુવાદ:', desc: 'વન-ક્લિક ઝડપી અનુવાદ' },
        detail3: { title: 'તાત્કાલિક અનુવાદ:', desc: 'શબ્દો અથવા વાક્યો તરત જ અનુવાદ કરો. ' },
        detail4: { title: 'ઇમેજ ટ્રાન્સલેશન:', desc: 'પ્રતીક્ષણોને અનુવાદિત પ્રતીક્ષણોથી બદલો.' },
        detail5: { title: 'વિડિયો અનુવાદ:', desc: 'સારા જોવા માટે દ્વીભાષી સબટાઇટલ્સ.' },
        footer: 'સ્માર્ટર ટ્રાન્સલેશન માટે વધુ AI-સક્ષમ રીડીંગ ફીચર્સનો અનુભવ કરો!',
      },
    },
    subtitle: 'PDF ઓનલાઇન ફ્રી માં અનુવાદ કરો',
    introduce: {
      module1: {
        detail1: {
          title: 'રિયલ-ટાઇમ સાઇડ-બાય-સાઇડ પીડીએફ અનુવાદ',
          desc1:
            'સીમультેનીયસ, બાજુ-બાજુ લેઆઉટમાં તાત્કાલિક રૂપે મૂળ અને અનુવાદિત સામગ્રી પ્રદર્શિત કરો',
          desc2: 'સિંક્રનાઇઝ્ડ સ્ક્રોલિંગ સાથે બંને સંસ્કરણોની સરળતાથી સરખામણી કરો',
          desc3: 'સતત વાંચન અનુભવ માટે સમાન ફોર્મેટિંગ જાળવી રાખો',
        },
        detail2: {
          title: 'ચોક્કસ સામગ્રી સંરેખણ અને સત્યાર્થતા ચકાસણી',
          desc1: 'સરળ ચકાસણી માટે સ્ત્રોત અને અનુવાદિત ટેક્સ્ટ વચ્ચે સંપૂર્ણ સંરેખણ',
          desc2: 'કન્ટેન્ટનો દરેક સેગમેન્ટ બંને સંસ્કરણોમાં ચોક્કસપણે મેળ ખાય છે',
          desc3: 'વિશ્વસનીય પરિણામો માટે અનુવાદમાંની વિસંગતતાઓ ઝડપથી શોધો અને હલ કરો',
        },
      },
      module2: {
        detail1: {
          title: 'ચોક્કસ અનુવાદ માટે બહુવિધ અદ્યતન AI મોડલ્સ',
          desc1: 'તમારી અનુવાદ आवશ્યકતાઓને મેળવવા માટે અગ્રણી AI મોડલોમાંથી પસંદ કરો',
          desc2: 'વિવિધ દસ્તાવેજ પ્રકારો અને ઉદ્યોગો માટે શ્રેષ્ઠ પરિણામો સુનિશ્ચિત કરો',
          desc3: 'લવચીક મોડેલ વિકલ્પો દરેક દૃશ્યા માટે અનુકૂલિત ઉકેલો પ્રદાન કરે છે',
        },
        detail2: {
          title: 'દરેક સામગ્રી પ્રકાર માટે અદ્યતન AI અનુવાદ',
          desc1: 'અમારું શક્તિશાળી AI મોડલ ઉચ્ચ ચોકસાઈ અને કુદરતી ભાષા સમજણ સુનિશ્ચિત કરે છે',
          desc2: 'તકનીકીય, શૈક્ષણિક અને સર્જનાત્મક દસ્તાવેજો સરળતાથી સંચાલિત કરે છે',
          desc3: 'તમારી તમામ અનુવાદની જરૂરિયાતો માટે વિશ્વસનીય પરિણામો પ્રદાન કરે છે',
          desc4: 'ઉત્તમ પ્રદર્શન માટે વિવિધ સામગ્રી પ્રકારોને બુદ્ધિશાળી રીતે અનુકૂલન કરવું',
        },
      },
      module3: {
        detail1: {
          title: 'બુદ્ધિશાળી દસ્તાવેજ ક્રિયાપ્રતિક્રિયા',
          desc1: 'ઉન्नત AI નો ઉપયોગ કરીને તમારા PDF અને પ્રેસેન્ટેશન ફાઇલો સાથે સરળતાથી ચેટ કરો',
          desc2: 'દસ્તાવેજની સામગ્રી વિશે તરત જ પ્રશ્નો પૂછો અને સચોટ જવાબો મેળવો',
          desc3: 'વિસ્તૃત દસ્તાવેજો માટે ઝડપથી સંક્ષિપ્ત સારાંશો બનાવો',
        },
        detail2: {
          title: 'ડીપ કન્ટેન્ટ એનાલિસિસ અને સીમલેસ ઇન્ટિગ્રેશન',
          desc1: 'AI-સંચાલિત સમજણ સાથે મુખ્ય માહિતી કાઢો અને જટિલ ડેટાનું વિશ્લેષણ કરો',
          desc2: 'તકનીકી、શૈક્ષણિક અથવા સર્જનાત્મક સામગ્રીમાં ઇન્સાઇટ્સ મેળવો',
          desc3:
            'સંપૂર્ણ દસ્તાવેજ સંચાલન સોલ્યુશન માટે અમારા PDF ટ્રાન્સલેટર સાથે સરળતાથી સંકલિત થાય છે',
        },
      },
      module4: {
        detail1: {
          title: 'PDF અનુવાદથી આગળ: ઓલ-ઇન-વન વેબપેજ અનુવાદ સોલ્યુશન',
          desc: 'દરેક ઓનલાઇન વાંચન સન્ગતિ માટે ડિઝાઇન કરેલી અમારી શક્તિશાળી સાઇડ-બાય-સાઇડ અનુવાદ એક્સ્ટેન્શનને શોધો.',
          desc1:
            'વેબપેજ અનુવાદ: સિંક્રનાઇઝ્ડ સાઇડ-બાય-સાઇડ દૃશ્ય સાથે બાયલિંગ્વલ સામગ્રીનો આનંદ લો',
          desc2: 'શબ્દ અનુવાદ: હાઇલાઇટ કરેલા શબ્દોને એક ક્લિકથી તરત જ અનુવાદ કરો',
          desc3:
            'ઇન્સ્ટન્ટ ટ્રાન્સલેશન: ઝડપી સમજ માટે કોઈપણ ટેક્સ્ટ અથવા વાક્યનું તાત્કાલિક અનુવાદ કરો',
          desc4: 'ઇમેજ ટ્રાન્સલેશન: મૂળ છબીઓને ટ્રાન્સલેટેડ સંસ્કરણો સાથે આપમેળે બદલો',
          desc5: 'વીડિયો અનુવાદ: સુધારેલ અનુભવ માટે બાઇલિંગ્વલ સબટાઇટલ્સ સાથે વીડિયો જુઓ',
        },
      },
    },
    question: {
      title: 'વારંવાર પૂછવામાં આવતા પ્રશ્નો',
      answer1: {
        title: 'નોમ પીડીએફ ટ્રાન્સલેટર પીડીએફ અનુવાદ માટે ફ્રી વપરાશ માટે છે કે નહી?',
        content:
          'હા, તમે સાઇડર પીડીએફ ટ્રાન્સલેટર વડે પીડીએફ ફ્રીમાં અનુવાદ કરી શકો છો! અમે 5,000 ટોકનનો ફ્રી ક્વોટા ઓફર કરીએ છીએ, જે બજારમાં સામાન્ય રીતે જોવા મળતા મોટા ભાગના પીડીએફ દસ્તાવેજો અનુવાદ કરવા માટે પૂરતું છે. જો તમારે મોટી ફાઇલો અનુવાદ કરવાની જરૂર છે અથવા અદ્યતન સુવિધાઓની જરૂર છે, તો તમે વધુ ક્ષમતાઓ માટે અમારી પ્રીમિયમ પ્લાન્સમાં અપગ્રેડ કરવાનું પસંદ કરી શકો છો. ',
      },
      answer2: {
        title: 'નોમ પીડીએફ ટ્રાન્સલેટર કેટલો સચોટ છે?',
        content:
          'નોઅમ પીડીએફ ટ્રાન્સલેટર અદ્યતન એઆઈ ટેકનોલોજીનો ઉપયોગ કરીને અને તમારા દસ્તાવેજોન સંદર્ભને ઊંડે સમજીને અત્યંત ચોકસાઇની અનુવાદો પ્રદાન કરે છે. જો કે કોઈ સ્વયંસંચાલિત અનુવાદ સંપૂર્ણ નથી, અમારું બાજુ-બાજુનું ડિસ્પ્લે તમને દરેક અનુવાદની સમીક્ષા અને સુધારણા કરવાની સરળતા આપે છે, જેનાથી અંતિમ પરિણામ તમારી ગુણવત્તાની અપેક્ષાઓને પૂર્ણ કરે છે. નોઅમ સાથે વિશ્વસનીય અને ચોકસાઇ પીડીએફ અનુવાદનો અનુભવ કરો. ',
      },
      answer3: {
        title: 'શું હું સ્કેન કરેલ PDFs નું અનુવાદ કરી શકું?',
        content:
          'હા, તમે અમારી બિલ્ટ-ઇન OCR (ઓપ્ટિકલ કેરેક્ટર રેકગ્નિશન) ટેકનોલોજી વડે સ્કેન કરેલ PDFsનું અનુવાદ કરી શકો છો. અમારી સિસ્ટમ સ્કેન કરેલ દસ્તાવેજો અને ઇમેજ-આધારિત PDFsમાંથી ટેક્સ્ટ આપમેળે બહાર કાઢે છે, પછી તમારા માટે સામગ્રીનું અનુવાદ કરે છે. આ બાંધવામાં આવે છે કે બિન-સંપાદનક્ષમ અથવા ફક્ત ઇમેજ PDFs પણ સચોટ રીતે અનુવાદ થઈ શકે છે.',
      },
      answer4: {
        title: 'અનુવાદ કેટલો સમય લે છે?',
        content:
          'અનુવાદ ઝડપી અને કાર્યક્ષમ છે—મોટા ભાગના દસ્તાવેજો સેકન્ડથી થોડા મિનિટ સુધીમાં પ્રક્રિયા કરવામાં આવે છે, તે તેમની લંબાઈ અને જટિલતા પર આધાર રાખે છે. ઉદાહરણ તરીકે, સ્ટાન્ડર્ડ 10-પૃષ્ઠ PDF અનુવાદ કરવામાં સામાન્ય રીતે 2 મિનિટથી ઓછો સમય લે છે. તમારી તમામ દસ્તાવેજ અનુવાદ જરૂરિયાતો માટે ઝડપી પરિણામ સમયનો આનંદ માણો!',
      },
      answer5: {
        title: 'શું હું વાંચન માટે સાઇડ-બાય-સાઇડ દૃશ્ય રાખી શકું?',
        content:
          'હા, તમે કોઈપણ સમયે તમારા દસ્તાવેજો બાજુબાજુ વાંચી શકો છો. આ લેઆઉટ તમને મૂળ અને અનુવાદિત સામગ્રીની સરળતાથી સરખામણી કરવાની મંજૂરી આપે છે, જે સરળ અને કાર્યક્ષમ વાંચન અનુભવ સુનિશ્ચિત કરે છે.',
      },
    },
    freeTrial: 'ફ્રી ટ્રાયલ',
    toLanguage: { title: 'પીડીએફ એઆઈ અનુવાદ જોડી', item: '{{સ્ત્રોત}} થી {{લક્ષ્ય}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'બ્લોગ',
      features: 'વિશેષતાઓ',
      button: 'હવે અનુવાદ કરો',
      pricing: 'કિરામત નિર્ધારણ',
      faq: 'વારંવાર પૂછાતા પ્રશ્નો',
    },
    hero: {
      upload: {
        title: 'તમારું PDF અપલોડ કરો',
        max: 'મેક્સ',
        highlight: 'બ્રાઉઝ કરવા માટે ક્લિક કરો',
        desc: 'અથવા ડ્રેગ અને ડ્રોપ કરો',
      },
      to: 'કે',
      title: 'ફ્રી પીડીએફ ટ્રાન્સલેટર',
      pill: 'એઆઈ-સંચાલિત પીડીએફ ટ્રાન્સલેટર',
      model: 'જીપીટી-4 અને ક્લોડ',
      desc: 'તાત્કાલિક, ચોક્કસ અનુવાદો જે મૂળ લેઆઉટને સાચવે છે. નોઅમ AI OCR અને સાઇડ-બાય-સાઇડ વ્યુને સપોર્ટ કરે છે.',
      free: 'મફત પ્રયાસ',
      support: 'OCR સપોર્ટ',
      translated: 'નોમ દ્વારા અનુવાદિત',
      complete: 'અનુવાદ પૂર્ણ',
    },
    ticker: {
      pdf: 'પીડીએફ અનુવાદ',
      ocr: 'ઓસીઆર ટેકનોલોજી',
      multi: 'બહુ-ભાષા',
      format: 'ફોર્મેટ રીટેન્શન',
      side: 'બાજુ-બાજુમાં',
      chat: 'પીડીએફ સાથે ચેટ કરો',
      web: 'વેબ અનુવાદ',
      secure: 'સુરક્ષિત અને ખાનગી',
    },
    comparison: {
      bad: {
        title: 'સ્ટાન્ડર્ડ અનુવાદ',
        head: 'ફોર્મેટીંગ અને કોન્ટેક્સ્ટ ગુમાવ્યું',
        text1: 'ભૂલ: લેઆઉટ તૂટી ગયું છે. ઇમેજો ખોટી જગ્યાએ છે.',
        text2: 'ટેક્સ્ટ ઓવરલેપ થાય છે અને ફોન્ટ્સ અસંગત છે. વાંચવું મુશ્કેલ અને અપ્રોફેશનલ છે...',
      },
      dump: { title: 'સાદો ટેક્સ્ટ ડમ્પ' },
      good: {
        title: 'નોએમ AI અનુવાદ',
        tag: 'સંપૂર્ણ પરિણામ',
        sub: 'સંપૂર્ણ ફોર્મેટિંગ, સંદર્ભ સભર',
      },
      title: 'નોમ AI કેમ પસંદ કરો?',
      desc: 'કોપી-પેસ્ટ અનુવાદ સાથે સંઘર્ષ કરવાનું બંધ કરો. સ્ટાન્ડર્ડ ટૂલ્સ અને અમારા AI-સઘન સંદર્ભ-સભાન અનુવાદ વચ્ચેનો તફાવત અનુભવો.',
    },
    showcase: {
      title2: 'કોઈપણ ભાષા',
      kicker: 'સપોર્ટેડ દસ્તાવેજો',
      title1: 'કોઈપણ દસ્તાવેજ',
      carousel1: 'કલા',
      carousel2: 'આર્કિટેક્ચર',
      carousel4: 'દવા',
      note: 'તકનીકી, શૈક્ષણિક અને સર્જનાત્મક દસ્તાવેજો સરળતાથી સંચાલો.',
      carousel3: 'શૈક્ષણિક જર્નલ',
      carousel5: 'ફાઇનાન્સ',
      carousel6: 'કાયદો',
      carousel7: 'કન્ટ્રાક્ટ',
      carousel8: 'નીતિ',
    },
    features: {
      big: {
        title: 'અડવાન્સ્ડ AI મોડલ્સ (GPT-4, ક્લોડ)',
        desc: 'તમારી અનુવાદ આવશ્યકતાઓને અનુરૂપ અગ્રણી AI મોડલ્સમાંથી પસંદ કરો. વિવિધ દસ્તાવેજ પ્રકારો માટે શ્રેષ્ઠ પરિણામો સુનિશ્ચિત કરો.',
      },
      grid1: {
        title: 'OCR સપોર્ટ',
        desc: 'સ્કેન કરેલ PDFs અને ઇમેજીસમાંથી ટેક્સ્ટ તરત જ કાઢો અને અનુવાદ કરો.',
      },
      grid2: {
        title: 'હાઇ-રેસ એક્સપોર્ટ',
        desc: 'મૂળ લેઆઉટ સાથે પીડીએફ ફોર્મેટમાં તમારા અનુવાદિત દસ્તાવેજો ડાઉનલોડ કરો. ',
      },
      grid3: {
        title: 'સાઇડ-બાય-સાઇડ સરખામણી',
        desc: 'મૂળ અને અનુવાદિત ટેક્સ્ટની તુલના કરવા માટે સિંક્રનાઇઝ્ડ સ્ક્રોલિંગ.',
      },
      title1: 'માત્ર અનુવાદ કરતાં વધુ',
      title2: 'ઇતો એક ક્રાંતિ છે',
      line1: 'ટેકનિકલ પેપર.pdf',
      line2: 'ભાષા શોધી રહ્યું છે: અંગ્રેજી...',
      line3: 'મોડેલ: GPT-4o (હાઇ પ્રીસીઝન)',
      line4: 'અનુવાદ પૂર્ણ (99% ચોકસાઈ)',
    },
    testimonials: {
      review1: {
        role: 'સંશોધક',
        content:
          'નોમ AI ने મને શૈક્ષણિક પેપરો અનુવાદિત કરવામાં કئی કલાક બચાવ્યા. તકનીકી શબ્દોને ચકાસવા માટે સાઇડ-બાય-સાઇડ વ્યુ અત્યંત મદદગાર છે.',
      },
      review2: {
        role: 'ગ્લોબલ માર્કેટર',
        content:
          'મેં ઉપયોગ કરેલ સૌથી સારું PDF અનુવાદક. તે મૂળ ફોર્મેટને સંપૂર્ણ રીતે જાળવી રાખે છે, જે અમારા માર્કેટિંગ ડેક્સ માટે નિર્ણાયક છે.',
      },
      review3: {
        role: 'કાનૂની સલાહકાર',
        content:
          'સચોટ અને ઝડપી છે. હું તેનો ઉપયોગ કરારના અનુવાદો માટે કરું છું અને સ્કેન કરેલ દસ્તાવેજો માટેનું OCR સુવિધા બિલકુલ સરળતાથી કામ કરે છે.',
      },
      kicker: 'વપરકારો દ્વારા પ્રિય',
      title: 'અમારા વપરાશકર્તાઓ શું કહે છે',
    },
    cta: {
      title: 'ભાષા અવરોધો તોડવા તૈયાર છો?',
      button: 'મફતમાં અનુવાદ કરવાનું શરૂ કરો',
      desc: '10,000+ વપરાશકર્તાઓ સાથે જોડાઓ અને આજે જ Noam AI સાથે તમારા દસ્તાવેજો અનુવાદ કરવાનું શરૂ કરો. ',
      hint: '',
    },
    languagePairs: {
      title: 'ઇંગલીશ PDF AI અનુવાદ જોડી',
      desc: 'નોમ AI દ્વારા સમર્થિત લોકપ્રિય અનુવાદ દિશાઓ',
    },
    footer: { about: 'અમારા વિશે', privacy: 'ગોપનીયતા નીતિ', contact: 'સપોર્ટ સાથે સંપર્ક કરો' },
  },
}

export default TRANSLATION
